export default {
  currencyFormat: "#,###.##",
  thousandSeparator: ",",
  salesInvoiceEditor: {
    glAccountName: "Gl Account",
    glAccountNo: "Gl Account No",
  },
  title: {
    store: "Tienda",
    budget: "Presupuesto",
    receivable: "Por Cobrar",
    client: "Cliente",
    payable: "Por Pagar",
    inventory: "Inventario",
    item: "Artículo",
    vendor: "Proveedor",
    masterData: "Datos Maestros",
    closeIncomeStatement: "Cerrar Estado de Resultados",
    documentApproval: "Aprobación de documento",
    storeRequisitionBatch: "Lote de Solicitud de Almacén",
    generalPostingGroup: "Grupo de Publicación General",
    generalProductPostingGroup: "Grupo de Publicación de Productos Generales",
    generalBusinessPostingGroup: "Grupo de Publicación de Negocios Generales",
    clientPostingGroup: "Grupo de Publicación de Clientes",
    vendorPostingGroup: "Grupo de Publicación de Proveedores",
    inventoryPostingGroup: "Grupo de Publicación de Inventario",
    bankAccountPostingGroup: "Grupo de Publicación de Cuenta Bancaria",
    inventoryReconciliationSetup: "Configuración de Reconciliación de Inventario",
    expenseGeneralProductPostingGroup: "Grupo de Publicación de Productos Generales para Gastos",
    expenseGeneralBusinessPostingGroup: "Grupo de Publicación de Negocios Generales para Gastos",
    vatPostingGroup: "Grupo de Publicación de IVA",
    vatBusinessPostingGroup: "Grupo de Publicación de IVA para Negocios",
    vatProductPostingGroup: "Grupo de Publicación de IVA para Productos",
    vatPostingSetup: "Configuración de Publicación de IVA",
    postingSetup: "Configuración de Publicación",
    generalPostingSetup: "Configuración de Publicación General",
    inventoryPostingSetup: "Configuración de Publicación de Inventario",
    userPostingSetup: "Configuración de Publicación de Usuario",
    signatureSetup: "Configuración de Firma",
    generalLedger: "Libro Mayor",
    chartOfAccount: "Plan de Cuentas",
    chartOfAccountCategory: "Categoría del plan de cuentas",
    chartOfAccountCategoryMenu: "COA Category",
    generalLedgerBudget: "Presupuesto del Libro Mayor",
    generalJournal: "Diario General",
    accountReconciliationJournal: "Diario de Reconciliación de Cuentas",
    newAccountReconciliationJournal: "Nuevo diario de Reconciliación de Cuentas",
    generalConfiguration: "Configuración General",
    warehouseLocation: "Ubicación del Almacén",
    accountingPeriod: "Período Contable",
    inventoryPeriod: "Período de Inventario",
    bankAccount: "Cuenta Bancaria",
    paymentTerm: "Término de Pago",
    generalJournalBatch: "Lote de Diario General",
    numberSeries: "Serie de Números",
    purchaseRequisitionBatch: "Lote de Solicitud de Compra",
    unitOfMeasurement: "Unidad de Medida",
    defaultUnitOfMeasurement: "Input Unidad de Medida Predeterminada",
    baseUnitOfMeasurement: "Base Unidad de Medida",
    inputUnitOfMeasurement: "Input Unidad de Medida",
    inputUnitOfMeasurementID: "ID de Input Unidad de Medida",
    inputUnitOfMeasurementName: "Nombre de Input Unidad de Medida",
    generalJournalTemplate: "Plantilla de Diario General",
    user: "Usuario",
    purchaseRequest: "Solicitud de Compra",
    purchaseOrder: "Orden de Compra",
    purchasing: "Compras",
    purchaseReceiving: "Recepción de Compra",
    purchaseReceiveCanceled: "Recepción de Compra Cancelada",
    outstandingPurchaseRequest: "Solicitud de Compra Pendiente",
    vatBreakdown: "Desglose del IVA",
    purchaseRequestList: "Lista de Solicitudes de Compra",
    storeRequisitionList: "Lista de Solicitudes de Almacén",
    storeRequisitionDetail: "Detalle de Solicitud de Almacén",
    postedStoreRequisitionList: "Lista de Solicitudes de Almacén Publicadas",
    storeRequisition: "Solicitud de Almacén",
    outstandingStoreRequisitionList: "Lista de Solicitudes de Almacén Pendientes",
    outstandingPurchaseRequestList: "Lista de Solicitudes de Compra Pendientes",
    outstandingPurchaseRequestDetail: "Detalle de Solicitud de Compra Pendiente",
    purchasePayableSetup: "Configuración de Cuentas por Pagar de Compra",
    salesReceivableSetup: "Configuración de Cuentas por Cobrar de Ventas",
    purchaseOrderDetail: "Detalle de Orden de Compra",
    purchaseReceiptDetail: "Detalle de Recepción de Compra",
    purchaseRequisitionTemplate: "Plantilla de Solicitud de Compra",
    purchaseRequisition: "Solicitud de Compra",
    purchaseRequestDetail: "Detalle de Solicitud de Compra",
    purchaseInvoiceDetail: "Detalle de Factura de Compra",
    currency: "Moneda",
    generalLedgerSetup: "Configuración del Libro Mayor",
    inventorySetup: "Configuración de Inventario",
    documentFlow: "Flujo de Documentos",
    masterDocumentFlow: "Flujo de Documentos Maestros",
    documentFlowSequenceType: "Tipo de Secuencia de Flujo de Documentos",
    purchaseInvoice: "Factura de Compra",
    purchaseCheck: "Cheque de Datos de Compra",
    itemLedgerEntry: "Entrada en el Libro Mayor de Artículos",
    itemJournalBatch: "Lote de Diario de Artículos",
    itemJournal: "Diario de Artículos",
    physicalInventoryJournal: "Diario de Inventario Físico",
    vendorLedgerEntry: "Entrada en el Libro Mayor de Proveedores",
    vendorLedgerEntryDetail: "Detalle de Entrada en el Libro Mayor de Proveedores",
    clientLedgerEntry: "Entrada en el Libro Mayor de Clientes",
    clientLedgerEntryDetail: "Detalle de Entrada en el Libro Mayor de Clientes",
    bankAccountLedgerEntry: "Entrada en el Libro Mayor de Cuentas Bancarias",
    bankAccountLedgerEntryDetail: "Detalle del asiento del libro mayor de la cuenta bancaria",
    physicalInventoryLedgerEntry: "Entrada en el Libro Mayor de Inventario Físico",
    vatEntry: "Entrada de IVA",
    valueEntry: "Entrada de Valor",
    itemApplicationEntry: "Entrada de Aplicación de Artículo",
    averageCostCalculationEntry: "Entrada de Cálculo de Costo Promedio",
    generalJournalEntry: "Entrada en el Diario General",
    postedDocuments: "Documentos Publicados",
    postedPurchaseRequest: "Solicitud de Compra Publicada",
    postedPurchaseOrder: "Orden de Compra Publicada",
    postedPurchaseReceipt: "Recepción de Compra Publicada",
    postedPurchaseInvoice: "Factura de Compra Publicada",
    postedPurchaseCreditMemo: "Nota de Crédito de Compra Publicada",
    postedSalesInvoice: "Factura de Venta Publicada",
    postedSalesCreditMemo: "Nota de Crédito de Venta Publicada",
    purchaseCreditMemo: "Nota de Crédito de Compra",
    postedStoreRequisition: "Solicitud de Almacén Publicada",
    postedReceivableInvoice: "Factura de Cuentas por Cobrar Publicada",
    entries: "Entradas",
    outstandingStoreRequisition: "Solicitud de Almacén Pendiente",
    adjustmentEntry: "Entrada de Ajuste",
    generalLedgerEntry: "Entrada en el Libro Mayor",
    paymentJournal: "Diario de Pagos",
    cashReceiptJournal: "Diario de Recepción de Efectivo",
    salesInvoice: "Factura de Venta",
    salesCreditMemo: "Nota de Crédito de Venta",
    appliedEntries: "Entradas Aplicadas",
    reports: "Informes",
    unapplyClientEntries: "Desaplicar Entradas de Cliente",
    applyClientEntries: "Aplicar Entradas de Cliente",
    unapplyVendorEntries: "Desaplicar Entradas de Proveedor",
    applyVendorEntries: "Aplicar Entradas de Proveedor",
    reverseTransaction: "Revertir Transacción",
    vendorBankAccount: "Cuenta Bancaria del Proveedor",
    reportSetting: "Configuración del Informe",
    itemJournalMasterTemplate: "Plantilla Maestra del Diario de Artículos",
    generalJournalMasterTemplate: "Plantilla Maestra del Diario General",
    journalVoucher: "Comprobante de Diario",
    paymentVoucher: "Comprobante de Pago",
    receivableInvoice: "Factura por Cobrar",
    accountReceivableAgingCreditCard: "Envejecimiento de Cuentas por Cobrar Tarjeta de Crédito",
    agingCreditCardReport: "Informe de Envejecimiento de Tarjeta de Crédito",
    accountReceivablePaymentList: "Lista de Pagos por Cobrar",
    accountReceivablePaymentListCard: "Lista de Pagos por Cobrar (Tarjeta)",
    accountReceivablePaymentListLedger: "Lista de Pagos por Cobrar (Libro Mayor)",
    purchaseRequestApproval: "Aprobación de Solicitud de Compra",
    approval: "Aprobación",
    printOption: "Opción de Impresión",
    purchaseBookOption: "Opción de Libro de Compras",
    inventoryReconciliation: "Conciliación de Inventario",
    entryEditorChangeAccountNumber: "Cambiar Número de Cuenta",
    entryEditorChangeDescription: "Cambiar Descripción",
    entryEditorChangeBankAccount: "Change Bank Account",
    entryEditorChangesLog: "Registro de Cambios",
    accountPayablePaymentList: "Lista de Pagos por Pagar",
    deleteBankAccountLedgerEntry: "Eliminar Entrada en el Libro Mayor de Cuenta Bancaria",
    deleteBankAccountLedgerEntryDialog: "Eliminar Entrada en el Libro Mayor de Cuenta Bancaria",
    choose: "Elegir",
    reopen: "Reabrir",
    gle: "GLE",
    baleDetail: "Detalle de BALE",
    bale: "BALE",
    chooseBaleEntry: "Elegir Entrada de BALE",
    confirmReopenClosedEntry: "Confirmar Reapertura de Entrada Cerrada",
    confirmDeleteGLE: "Confirmar Eliminación de GLE",
    confirmDeleteBaleDetail: "Confirmar Eliminación de Detalle de BALE",
    confirmDeleteBale: "Confirmar Eliminación de BALE",
    deletePostedInvoice: "Eliminar Factura Publicada",
    movePurchaseInvoiceLines: "Mover Líneas de Factura de Compra",
    withdrawDocumentApproval: "Retirar Aprobación de Documento",
    purchaseInvoiceApprovalDetail: "Detalle de Aprobación de Factura de Compra",
    changeStatus: "Cambiar Estado",
    changeStatusPurchaseRequisition: "Cambiar Estado de Solicitud de Compra",
    cle: "CLE",
    vle: "VLE",
    cleDetail: "Detalle de CLE",
    vleDetail: "Detalle de VLE",
    chooseCleEntry: "Elegir Entrada de CLE",
    chooseVleEntry: "Elegir Entrada de VLE",
    confirmDeleteCleDetail: "Confirmar Eliminación de Detalle de CLE",
    confirmDeleteCle: "Confirmar Eliminación de CLE",
    confirmDeleteVleDetail: "Confirmar Eliminación de Detalle de VLE",
    confirmDeleteVle: "Confirmar Eliminación de VLE",
    deleteClientLedgerEntry: "Eliminar CLE",
    deleteClientLedgerEntryDialog: "Eliminar Entrada en el Libro Mayor de Cliente",
    deleteVendorLedgerEntry: "Eliminar VLE",
    deleteVendorLedgerEntryDialog: "Eliminar Entrada en el Libro Mayor de Proveedor",
    updateWitholdingTax: "Actualizar Impuesto de Retención",
    adjustmentTools: "Herramientas de Ajuste",
    adjustSingleEntry: "Ajustar Entrada Individual",
    adjustSOH: "Ajustar SOH",
    adjustCostItemEntries: "Ajustar entradas de elementos de costo",
    documentAttachment: "Adjunto de Documento",
    recallJournal: "Recordar Diario",
    reverseJournal: "Revertir Diario",
    inventoryAccountBalanceDetail: "Detalle del Saldo de Cuenta de Inventario",
    recalled: "Recordado",
    changeClient: "Cambiar Cliente",
    itemCostPerLocation: "Costo del artículo por ubicación",
    integration: "Integración",
    interDepartmentTransferDetail: "Detalle de transferencia entre departamentos",
    revaluationJournalAllItems: "Revaluación Diario Todos los Artículos",
    generalLedgerEntryChangesLogs: "Registros de Cambios en Asientos del Libro Mayor",
    changeItem: "Cambiar {item}",
    itemJournalLog: "Registro de diario de artículos",
    purchaseRequestApprovalDetail: "Detalle de Aprobación de Solicitud de Compra",
    purchaseOrderApprovalDetail: "Detalle de Aprobación de Orden de Compra",
    storeRequestApprovalDetail: "Detalle de Aprobación de Solicitud de Almacén",
    revertPostedSalesInvoice: "Revertir factura de venta publicada",
    changesLogs: "Registros de Cambios",
    cancelledPurchaseReceipts: "Recibos de Compra Cancelados",
    salesInvoiceLine: "Línea de Factura de Venta",
    newPaymentJournal: "Nuevo Diario de Pagos",
    newCashReceiptJournal: "Nuevo Diario de Recibos de Efectivo",
    itemsWithIncorrectCosts: "Artículos con costos incorrectos",
    ve: "VE",
    chooseVeEntry: "Elegir entrada VE",
    confirmDeleteVe: "Confirmar eliminar VE",
    deleteValueEntry: "Eliminar VE",
    deleteValueEntryDialog: "Eliminar entrada de valor",
    deleteGeneralJournalEntryDialog: "Eliminar Registro del Diario General",
    selfBilledInvoice: "Factura Autogenerada",
    taxIntegrationLog: "Registro de Integración Fiscal",
    updateStoreRequisition: "Actualizar estado de requisición de tienda",
    printoutLayout: "Formato de Impresión",
    adjustPostingDate: "Ajustar Fecha de Publicación",
    invoiceEmailLog: "Registro de Correos de Factura",
    inventoryPostingGroups: "Grupos de Publicación de Inventario",
    entryEditorChangeAccountNumberAndDescription: "Cambiar Número de Cuenta y Descripción",
    revertPostedPurchaseInvoice: "Revertir Factura de Compra Publicada",
    changeLineStatus: "Cambiar Estado de Línea",
    dimension: "Dimensión",
    dimensionValueType: "Tipo de Valor de Dimensión",
    dimensionValue: "Valor de Dimensión",
    dimensionOption: "Opción de Dimensión",
    coaDimension: "Dimensión COA",
    coaDimensionOptions: "Opciones de Dimensión COA",
    coaDimensionMatrix: "Matriz de Dimensiones COA",
    updateCoaDimensionMapping: "Actualizar Mapeo de Dimensiones COA",
    defaultDimension: "Dimensión Predeterminada",
    dimensionRule: "Regla de Dimensión",
    dimensionRules: "Reglas de Dimensión",
    allowedDimensionValues: "Valores de Dimensión Permitidos",
    documentDimension: "Dimensión del Documento",
    approvalDocumentWithdrawal: "Retiro de Documento de Aprobación",
    deleteEntries: "Eliminar entradas",
    confirmDeletePurchaseInvoice: "Confirmar eliminación de factura de compra",
    storeRequisitionTemplate: "Plantilla de Solicitud de Almacén",
    deletePostedMemo: "Eliminar memo publicado",
    entryEditorChangeDimensionSet: "Cambiar Conjunto de Dimensiones",
    revertPostedPurchaseCreditMemo: "Revertir Nota de Crédito de Compra Publicada",
    ytdAddAdditionalYear: "Añadir Año Adicional (Comparación de Informe YTD)",
    depositAccountPostingGroup: "Grupo de Publicación de Cuenta de Depósito",
    depositAccount: "Cuenta de Depósito",
    depositAccountLedgerEntry: "Entrada de Libro de Cuentas de Depósito",
    depositAccountLedgerEntryDetail: "Detalle de Entrada del Libro de Cuentas de Depósito",
    deleteDepositAccountLedgerEntry: "Eliminar DALE",
    deleteDepositAccountLedgerEntryDialog: "Eliminar entrada de libro mayor de cuenta de depósito",
    daleDetail: "Detalle DALE",
    dale: "DALE",
    chooseDaleEntry: "Seleccionar Entrada de Dale",
    confirmDeleteDaleDetail: "Confirmar eliminar detalle DALE",
    confirmDeleteDale: "Confirmar eliminar DALE",
    interDepartmentTransferApprovalDetail: "Detalle de Aprobación de Transferencia entre Departamentos",
    dimensionLevel: "Nivel de Dimensión",
    generalBudgetEntry: "Entrada de Presupuesto General",
    generalBudgetJournal: "Diario de Presupuesto General",
    reportByDimension: "Informe por Dimensión",
    profitAndLossBudgetSource: "Fuente de Presupuesto de Pérdidas y Ganancias",
    deleteSelectedInvoices: "Eliminar Facturas Seleccionadas",
    confirmDimensionSet: "Confirmar conjunto de dimensiones",
    cashFlowBudget: "Presupuesto de Flujo de Efectivo",
    interDepartmentTransfer: "Transferencia entre departamentos",
    interDepartmentTransferBatch: "Lote de transferencia entre departamentos",
  },
  word: {
    entryNo: "Entry No.",
    chooseThePrintingPageSize: "Choose the printing page size",
    changedTo: "To",
    chooseThePurchaseBookOption: "Choose the purchase book option",
    importRejected: "Importación rechazada. Corrija estas filas e importe de nuevo.",
    importWithReservationSuccess: "Importadas {invoices} facturas y {reservations} reservas.",
  },
  main: {
    search: "Search",
    account: "Account",
    interimAccount: "Interim Account",
  },
  form: {
    purchaseOrders: "Purchase Orders",
    purchaseRequest: "Purchase Request",
    outstandingPurchaseRequest: "Outstanding Purchase Request",
    receiving: "Receiving",
    info: "Info",
    vendors: "Vendors",
    items: "Items",
    breakdowns: "Breakdowns",
  },
  button: {
    directExpense: "configurar como Gasto Directo",
    correction: "Hacer Corrección de Aplicación Fija",
    setVendor: "Configurar Proveedor",
    preview: "Vista Previa",
    resetEntry: "Restablecer Todas las Entradas",
    manageBankAccount: "Gestionar Cuenta Bancaria",
    viewDetail: "Ver Detalles",
    viewAppliedEntries: "Entradas Aplicadas",
    viewEntries: "Ver Entradas",
    previewUndoReceipt: "Vista Previa de Deshacer Recibo",
    cancelReceipt: "Cancelar Recibo",
    previewCancelReceipt: "Vista Previa de Cancelar Recibo",
    delete: "Eliminar",
    deleteBy: "Eliminar por {f}",
    deleteByIleId: "Eliminar por ID de ILE",
    deleteByDocumentNo: "Eliminar por Nº de Documento",
    createCreditMemo: "Crear Nota de Crédito Correctiva",
    calculateInventory: "Calcular Inventario",
    refreshUnitCost: "Actualizar Costo Unitario",
    upload: "Subir",
    download: "Descargar",
    downloadTemplate: "Descargar Plantilla",
    previewData: "Vista Previa de Datos",
    import: "Importar",
    view: "Ver",
    new: "Nuevo",
    edit: "Editar",
    ok: "Aceptar",
    cancel: "Cancelar",
    save: "Guardar",
    recalculateAverageCost: "Recalcular Costo Promedio",
    add: "Añadir",
    choose: "Seleccionar",
    print: "Imprimir",
    post: "Registrar",
    unpost: "Anular Registrar",
    previewPost: "Vista Previa de Registro",
    printSupplierComparison: "Imprimir Comparación de Proveedores",
    insertFromTemplate: "Insertar Desde Plantilla",
    applyEntries: "Aplicar Entradas",
    unapplyEntries: "Desaplicar Entradas",
    process: "Procesar",
    processToPo: "Procesar a Orden de Compra",
    reject: "Rechazar",
    decline: "Declinar",
    approve: "Aprobar",
    submitApproval: "Enviar para Aprobación",
    reopen: "Reabrir",
    release: "Liberar",
    select: "Seleccionar",
    close: "Cerrar",
    move: "Mover",
    clear: "Limpiar",
    saveChange: "Guardar Cambios",
    saveAsTemplate: "Guardar como Plantilla",
    addNewTemplate: "Añadir Nueva Plantilla",
    AddFromReceipt: "Añadir Desde Recibo",
    reset: "Restablecer",
    apply: "Aplicar",
    addFilter: "Añadir Filtro",
    navigate: "Navegar",
    reverse: "Revertir",
    forceClose: "Cierre Forzoso",
    receiveAll: "Configurar Recibir Todo",
    ClearReceive: "Limpiar Recepción",
    closePeriod: "Cerrar Período",
    reopenPeriod: "Reabrir Período",
    reopenPeriodForce: "Reabrir Período (Forzar)",
    closeMonthPeriod: "Cerrar Período Mensual",
    reopenMonthPeriod: "Reabrir Período Mensual",
    reopenMonthPeriodForce: "Reabrir Período Mensual (Forzar)",
    closeYearPeriod: "Cerrar Período Anual",
    reopenYearPeriod: "Reabrir Período Anual",
    viewPrice: "Ver Precio",
    newItem: "Nuevo Artículo",
    splitItem: "Dividir Artículo",
    postAndPrint: "Registrar e Imprimir",
    vendorEntries: "Entradas del Proveedor",
    postBatch: "Registrar Lote",
    getPostedSalesInvoice: "Obtener Factura de Venta Registrada",
    setQtyToZero: "Configurar Cantidad a Cero",
    showOpenOnly: "Mostrar Solo Abiertos",
    history: "Historial",
    released: "Liberado",
    deleted: "Eliminado",
    showData: "Mostrar Datos",
    newItemFromPR: "Nuevo Artículo Desde Solicitud de Compra",
    setReconciled: "Configurar Reconciliado",
    unsetReconciled: "Desconfigurar Reconciliado",
    downloadToGSheet: "A Hoja de Cálculo de Google",
    downloadToExcel: "A Excel",
    downloadToPDF: "A PDF",
    goToSetup: "Ir a Configuración",
    goToInvReconSetup: "Ir a Configuración de Reconciliación de Inventario",
    goToInventorySetup: "Ir a Configuración de Inventario",
    applyEntriesFromInvoice: "Aplicar Entradas desde Factura",
    applyEntriesFromCreditMemo: "Aplicar Entradas desde Nota de Crédito",
    submit: "Enviar",
    submitForApproval: "Enviar para Aprobación",
    deleteAll: "Eliminar Todo",
    approvalDetail: "Detalle de Aprobación",
    delegate: "Delegar",
    withdraw: "Retirar",
    previewAdjustCostEntries: "Vista Previa de Ajuste de Entradas de Costo",
    adjustCostEntries: "Ajustar Entradas de Costo",
    splitInvoice: "Dividir Factura",
    selectAll: "Seleccionar Todo",
    unselectAll: "Deseleccionar Todo",
    back: "Atrás",
    next: "Siguiente",
    confirm: "Confirmar",
    recall: "Recuperar",
    refresh: "Actualizar",
    viewAccount: "Ver Cuenta",
    viewDimension: "Ver Dimensión",
    undoForceClose: "Deshacer cierre forzado",
    adjustValueEntryAmount: "Ajustar importe de entrada de valor",
    newSet: "Nuevo Conjunto",
    invoicedOnly: "Solo facturado",
    updateStatus: "Actualizar Estado",
    importHOAInvoice: "Importar factura de HOA",
    undo: "Deshacer",
    clearAll: "Limpiar todo",
    recalculateInventory: "Recalcular Inventario",
    revert: "Revertir",
    lineStatusFilter: "Filtro de Estado de Línea",
    create: "Crear",
    selectDimensionValues: "Seleccionar Valores de Dimensión",
    includeClosedInvoice: "Incluir factura cerrada",
    includeClosedEntry: "Incluir entrada cerrada",
    addDimension: "Agregar Dimensión",
    approvalNotes: "Notas de Aprobación",
    importInvoiceWithReservation: "Importar Factura con Reserva",
    readSheet: "Leer hoja",
    newLine: "Nueva línea",
  },
  radio: {
    autoclose: "Autoclose",
    manualclose: "Cerrar manual",
  },
  excel: {
    excel: "Excel",
    upload: "Subir",
    uploadInsert: "Subir (Insertar)",
    uploadUpdate: "Subir (Actualizar)",
    download: "Descargar",
    downloadTemplate: "Descargar Plantilla",
    preview: "Vista Previa de Datos",
    import: "Importar",
    cancel: "Cancelar",
    importSuccess: "Importación exitosa",
    importFailed: "Error al importar",
    downloadFailed: "Error al descargar los datos",
    parseFailed: "Error al analizar el archivo Excel",
    noValidRows: "No hay filas válidas para importar",
    noDataRows: "El archivo no tiene filas de datos",
    invalidFileType: "Solo se admiten archivos .xlsx",
    fileTooLarge: "El archivo debe ser menor a {size}MB",
    showingTruncated: "Mostrando {limit} de {total} filas — se importarán las {total} filas.",
    missingColumns: "Importación bloqueada — faltan columnas esperadas: {columns}. Por favor descargue la plantilla de nuevo.",
  },
  select: {
    base: "Select {f}",
  },
  reports: {
    allVendor: "All Vendor",
    noVendor: "No Vendor",
    vendorList: "Vendor List",
    earliestPostingDate: "Earliest Posting Date",
    latestPostingDate: "Latest Posting Date",
    selectVendor: "Select Vendor",
    detailLocationSummary: "Resumen de ubicación detallada",
    pnlFileID: "ID de archivo de Excel de pérdidas y ganancias {f}",
    exportPnl: "Ganancias y pérdidas {f}",
    pnlID: "ID de pérdidas y ganancias {f}",
    downloadToExcel: "Descargar a Excel",
    profitAndLossCurrentMonthConsolidationExcelFileID: "ID de Archivo Excel de Consolidación de Pérdidas y Ganancias del Mes Actual",
    profitAndLossYTDConsolidationExcelFileID: "ID de Archivo Excel de Consolidación de Pérdidas y Ganancias del Año Hasta la Fecha",
    profitAndLossYTDSummaryExcelFileID: "ID de Archivo Excel de Resumen de Pérdidas y Ganancias del Año Hasta la Fecha",
    balanceSheetExcelFileID: "ID de Archivo Excel de Coste Diario Rápido",
    dailyFlashCostExcelFileID: "ID de Archivo Excel de Coste Diario Rápido",
    DRRExcelFileID: "ID de Archivo Excel DRR",
    FBMealCoverExcelFileID: "ID de Archivo Excel de Cubierta de Comida FB",
    profitAndLossCurrentMonthConsolidationGoogleSheetFileID: "ID de Archivo Google Sheet de Consolidación de Pérdidas y Ganancias del Año Hasta la Fecha",
    profitAndLossYTDConsolidationGoogleSheetFileID: "ID de Archivo Google Sheet de Consolidación de Pérdidas y Ganancias del Año Hasta la Fecha",
    profitAndLossYTDSummaryGoogleSheetFileID: "ID de Archivo Google Sheet de Resumen de Pérdidas y Ganancias del Año Hasta la Fecha",
    balanceSheetGoogleSheetFileID: "ID de Archivo Google Sheet de Balance General",
    dailyFlashCostGoogleSheetFileID: "ID de Archivo Google Sheet de Coste Diario Rápido",
    DRRGoogleSheetFileID: "ID de Archivo Google Sheet DRR",
    FBMealCoverGoogleSheetFileID: "ID de Archivo Google Sheet de Cubierta de Comida FB",
    startInventoryAccountNumber: "Número de Cuenta de Inventario Inicial",
    endInventoryAccountNumber: "Número de Cuenta de Inventario Final",
    accountPayableInterim: "Cuenta por Pagar Interina",
    inventoryDiscrepancyReport: "Informe de Discrepancias de Inventario",
    inventoryFood: "Inventario de Alimentos",
    inventoryBeverage: "Inventario de Bebidas",
    invAccBalanceSOH: "Saldo de Cuenta de Inventario vs. SOH",
    financialReport: "Informe Financiero",
    accountPayableReport: "Informe de Cuentas por Pagar",
    accountReceivableReport: "Informe de Cuentas por Cobrar",
    inventoryReport: "Informe de Inventario",
    frontOfficeReport: "Informe de Front Office",
    balanceSheet: "Balance General",
    balanceSheetYTDSummary: "Resumen de Balance General YTD",
    trialBalance: "Balance de Comprobación",
    profitAndLoss: "Ganancias y Pérdidas",
    profitAndLossYTDSummary: "Resumen de Ganancias y Pérdidas YTD",
    accountPayableAging: "Antigüedad de Cuentas por Pagar",
    accountPayableInterimAging: "Antigüedad Interina de Cuentas por Pagar",
    accountPayablePaymentList: "Lista de Pagos de Cuentas por Pagar",
    accountReceivableAging: "Antigüedad de Cuentas por Cobrar",
    accountReceivableAgingCard: "Tarjeta de Antigüedad de Cuentas por Cobrar",
    accountReceivablePaymentList: "Lista de Pagos de Cuentas por Cobrar",
    accountReceivablePaymentListCard: "Tarjeta de Lista de Pagos de Cuentas por Cobrar",
    accountReceivablePaymentListLedger: "Libro Mayor de Lista de Pagos de Cuentas por Cobrar",
    inventoryAccountBalanceDetail: "Detalle de Balance de Cuenta de Inventario",
    stockOnHand: "Stock Disponible",
    topPurchaseItem: "Artículo de Compra Principal",
    topPurchaseByVendor: "Compra Principal Por Proveedor",
    topPurchaseByVendorReport: "Informe de Compras Principales Por Proveedor",
    vendorReport: "Informe de Proveedor",
    dailyFlashCost: "Costo Diario Flash",
    slowMovingInventory: "Inventario de Baja Rotación",
    itemExpense: "Gasto de Artículo",
    receivingReport: "Informe de Recepción",
    inventoryReconciliation: "Conciliación de Inventario",
    itemReorder: "Reorden de Artículo",
    outstandingPurchaseOrder: "Orden de Compra Pendiente",
    forceClosedPurchaseOrder: "Orden de Compra Cerrada Forzosamente",
    purchasingReport: "Informe de Compras",
    guestAccountBalance: "Balance de Cuenta de Huésped",
    FOClosingCashier: "Cierre de Cajero FO",
    POSClosingCashier: "Cierre de Cajero POS",
    dailyRevenueReport: "Informe de Ingresos Diarios",
    FBMealCover: "Cobertura de Comidas FB",
    incomeAudit: "Auditoría de Ingresos",
    budgetRevenue: "Presupuesto de Ingresos",
    budgetStatistic: "Estadística Presupuestaria",
    showGuestAccountName: "Mostrar Nombre de Invitado/Cuenta",
    showSalesPersonName: "Mostrar Mombre del Vendedor",
    showContactName: "Mostrar Nombre de Contacto",
    agingDate: "Fecha de Envejecimiento",
    discrepancyReport: "Informe de Discrepancia",
    discrepancy: "Discrepancia",
    agingBy: "Envejeciendo por",
    arAgingReport: "Informe de Envejecimiento de Cuentas por Cobrar",
    cardAgingReport: "Informe de Envejecimiento de Tarjetas",
    arAgingAccountSetup: "Configuración de cuenta AR antigua",
    arAgingAccountSetupNotes: "Esto se utiliza en la discrepancia del saldo del informe de antigüedad de AR.",
    apAgingAccountSetup: "Configuración de cuenta AP antigua",
    apAgingAccountSetupNotes: "Esto se utiliza en la discrepancia del saldo del informe de antigüedad de AP.",
    arAgingDiscrepancyReport: "AR Aging Informe de Discrepancia",
    arAgingDiscrepancy: "AR Aging Discrepancia",
    apAgingDiscrepancyReport: "AP Aging Informe de Discrepancia",
    apAgingDiscrepancy: "AP Aging Discrepancia",
    bankAccountAgingDiscrepancyReport: "Informe de Discrepancia en el Envejecimiento de Cuentas Bancarias",
    bankAccountAgingDiscrepancy: "Discrepancia en el Envejecimiento de Cuentas Bancarias",
    arAgingCardAndLedger: "Tarjeta y Libro Mayor de Antigüedad de Cuentas por Cobrar",
    arAgingCardAndLedgerReport: "Tarjeta y Libro Mayor de Antigüedad de Cuentas por Cobrar",
    TBSummaryGoogleSheetFileID: "ID del archivo de Google Sheet del Balance de Comprobación",
    TBSummaryExcelFileID: "ID del archivo de Excel del Balance de Comprobación",
    excelTemplateIsNotConfiguredYet: "La plantilla de Excel aún no está configurada",
    gsheetTemplateIsNotConfiguredYet: "La plantilla de GSheet aún no está configurada",
    downloadAsMacro: "Descargar como Macro",
    accountScheduleConsolidation: "Consolidación de Programación de Cuentas",
    accountScheduleConsolidationReport: "Informe de Consolidación de Cuentas",
    accountScheduleConsolidationExcelFileID: "ID del archivo Excel de Consolidación de Programación de Cuentas",
    accountScheduleConsolidationGoogleSheetFileID: "ID del archivo de Google Sheet de Consolidación de Programación de Cuentas",
    inventoryFoodDiscrepancy: "Diferencia de Inventario de Alimentos",
    inventoryBeverageDiscrepancy: "Discrepancia de Inventario de Bebidas",
    invAccBalanceSOHDiscrepancy: "Diferencia entre saldo de cuenta de inventario y SOH",
    profitAndLossCurrentMonthConsolidation: "Consolidación de Pérdidas y Ganancias del Mes Actual",
    profitAndLossYTDConsolidation: "Consolidación de Pérdidas y Ganancias YTD",
    inventoryMovementReport: "Informe de Movimiento de Inventario",
    notAvailableForPreview: "{item} no está disponible para vista previa. Por favor, descarga el informe para ver estos datos.",
    trialBalanceYTD: "Balance de Prueba YTD",
    itemConsumptionReport: "Informe de Consumo de Artículos",
    interfaceJournal: "Diario de Interfaz",
    includeDimension: "Incluir Columnas de Dimensión",
    useReceivableDateAging: "Usar Fecha de Vencimiento / Fecha de Publicación",
    accountPayableInterimIsNotConfiguredYet: "La cuenta provisional de cuentas por pagar no está configurada. Por favor, configúrela en la configuración del informe.",
    accountPayableInterimAccountNotFound: "La cuenta provisional de Cuentas por Pagar configurada no se encontró en el Plan de Cuentas.",
    cashFlowExcelFileID: "ID de archivo de Excel de flujo de efectivo",
    cashFlowYTDSummaryExcelFileID: "ID de archivo Excel de resumen de flujo de caja YTD",
    excelTemplateNotUploaded: "Plantilla de Excel no cargada. Cárgala en Datos Maestros > Configuración General > Configuración de Informes.",
    cashFlow: "Flujo de Caja",
    cashFlowYTDSummary: "Resumen de Flujo de Efectivo YTD",
    cashFlowNotConfigured: "No se ha configurado ninguna dimensión de flujo de efectivo. Agregue una en Configuración del Libro Mayor → Informes por Dimensión → Flujo de Efectivo.",
    actualCurrentMonth: "Mes Actual",
    budgetCurrentMonth: "Presupuesto Mes Actual",
    actualLastMonth: "Actual Último Mes",
    actualLastYear: "Actual del Año Pasado",
    actualYTDCurrentMonth: "Actual YTD Mes Actual",
    budgetYTDCurrentMonth: "Presupuesto Acum. Mes Actual",
    actualYTDLastYear: "Actual YTD Año Pasado",
    cashFlowByDepartmentExcelFileID: "ID del archivo Excel de flujo de efectivo por departamento",
    cashFlowByDepartment: "Flujo de Caja por Departamento",
    cashFlowByDepartmentNotConfigured: "Configura dos dimensiones en Configuración del Libro Mayor → Informes por Dimensión → Flujo de Efectivo por Departamento: la primera es el eje de filas, la segunda el eje de columnas.",
    cashFlowMonthToDate: "Mes hasta la fecha",
    cashFlowYearToDate: "Año hasta la fecha",
    cashFlowUnassigned: "No asignado",
    cashFlowTotal: "TOTAL",
  },
  status: {
    pleaseWait: "Please wait...",
    loadingpleaseWait: "Loading... Please wait",
    trialBalanceDetail: {
      generatingData: "Generating trial balance details is in progress. Please wait; this may take a while. You can either close the tab/window or redirect to another page; the process will continue running.",
      readyForDownload: "The trial balance detail file is now available for download: ",
      sendEmail: "and send to email:",
      exclusiveDownload: "The detailed results of the trial balance are not available for web display and can only be accessed exclusively through file download. <br> For datasets with more than 5,000 rows, kindly utilize the Excel download option.",
      gsheeRowLimitExceeded: "The row limit for Google Sheets has been exceeded. Please consider downloading the file as an Excel document instead.",
      downloadPartialMessage: "El archivo de saldo de prueba se dividirá por mes. Evite cerrar el navegador durante este proceso.",
      periodStarted: "La generación del archivo Excel para el período de {p} ha comenzado.",
      inProgressFile: "Generando archivo en progreso:",
      willSendToEmail: "El archivo de detalles del balance de prueba se está generando y se enviará a {email} al finalizar.",
      csvOptionDownload: "Para períodos mayores a un mes, use la descarga CSV.",
      rowLimitExceeded: "This range has {rows} ledger entries (max {max}). Narrow the date range or use the CSV download.",
    },
    disabledDueToQuantityReceived: "Disabled due to the existence of quantity received",
    purchaseReceivingDetail: {
      generatingData: "Generando detalles del informe de recepción. Por favor, espere; esto puede tardar un momento. Puede cerrar la pestaña/ventana o redirigirse a otra página; el proceso seguirá en ejecución.",
      readyForDownload: "El archivo de detalles del informe de recepción ya está disponible para descargar:",
      sendEmail: "y enviar a correo:",
      exclusiveDownload: "Los resultados detallados del informe de recepción no están disponibles para visualización web y solo se pueden acceder mediante descarga de archivo. <br> Para conjuntos de datos con más de 5,000 filas, utilice la opción de descarga en Excel.",
      gsheeRowLimitExceeded: "Se ha superado el límite de filas de Google Sheets. Considere descargar el archivo como un documento de Excel.",
    },
    commonReportDetail: {
      generatingData: "Generando detalles de {f1}. Por favor, espere; esto puede tardar un momento. Puede cerrar la pestaña/ventana o redirigirse a otra página; el proceso seguirá en ejecución.",
      readyForDownload: "El archivo de detalles {f1} ya está disponible para descargar:",
      sendEmail: "y enviar a correo:",
      exclusiveDownload: "Los resultados detallados de {f1} no están disponibles para visualización web y solo se pueden acceder mediante descarga de archivo. <br> Para conjuntos de datos con más de {f2} filas, utilice la opción de descarga en Excel.",
      gSheetRowLimitExceeded: "Se ha superado el límite de filas de Google Sheets. Considere descargar el archivo como documento de Excel.",
    },
    exclusiveDownload: "Los resultados detallados no están disponibles para mostrar en la web. Utilice la opción de descarga para ver los detalles completos.",
    willSendToEmail: "El archivo se está generando y se enviará a {email} al finalizar.",
  },
  confirm: {
    processing: "Processing, please wait",
    noAccess: "No Access",
    correctionTitle: "Fixed Apply Correction",
    correction: "Are you sure to make correction for {f}",
    receiveAllHeader: "Set to receive All",
    receiveAll: "Set to receive all quantity?",
    receiveAllFailed: "Set Receive All Failed",
    noEntryPreviewPost: "This post has not generate any entries",
    deleteHeader: "Delete {f}",
    deleteCanUndo: "Are you sure you want to delete {f}?",
    delete: "Are you sure you want to delete {f}? This process cannot be undone.",
    deleteBatch: "Are you sure you want to delete {f1} rows of {f2}? This process cannot be undone.",
    deleteSuccess: "{f} has been deleted successfully!",
    deleteFailed: "Error, cannot delete {f}.",
    updateSuccess: "{f} has been saved successfully!",
    updateFailed: "Error, cannot save {f}.",
    printFailed: "Error, cannot print {f}.",
    importSuccess: "{f} has been imported successfully!",
    importFailed: "Error, cannot import {f}.",
    dialogClosing: "Dialog Closing",
    releaseSuccess: "{f} has been released successfully!",
    releaseFailed: "Error, cannot release {f}.",
    reopenSuccess: "{f} has been re-opened successfully!",
    reopenFailed: "Error, cannot re-open {f}.",
    reopenFailedAlreadyProcessed: "Error, cannot re-open {f}. Order already received",
    closeSuccess: "{f} has been close successfully!",
    closeFailed: "Error, cannot close {f}.",
    restore: "Are you sure you want to restore {f}?",
    restoreHeader: "Restore {f}",
    restoreFailed: "Error, cannot restore {f}.",
    restoreSuccess: "{f} has been restored successfully!",
    setToNonDirectExpense: "Estás seguro de que deseas establecer como gasto no directo {f}?",
    setToNonDirectExpenseHeader: "Establecer como gasto no directo {f}",
    setToNonDirectExpenseFailed: "Error, no se puede establecer como gasto no directo {f}.",
    setToNonDirectExpenseSuccess: "{f} se ha establecido como gasto no directo con éxito!",
    applyEntriesSuccess: "Entries has been applied successfully!",
    applyEntriesFailed: "Error, failed to apply entries {f}.",
    unapplyEntriesSuccess: "Entries has been unapplied successfully!",
    unapplyEntriesFailed: "Error, failed to unapply entries {f}.",
    reverseEntriesSuccess: "Entries has been reversed successfully!",
    reverseEntriesFailed: "Error, failed to reverse entries {f}.",
    postedSuccess: "{f} has been posted successfully!",
    postedFailed: "Error, cannot post {f}.",
    postedFailedUnitCostZero: "Error, cannot post {f}. Unit Cost can't be 0.",
    postHaveNegativeAdjustment: "Warning, posting this will add negative adjustment. Proceed?",
    processSuccess: "{f} has been processed successfully!",
    processedItems: "- {f1} ({f2}), quantity {f3} {f4}",
    processAlready: "These item(s) already processed as PO:<br/>{f}",
    hasZeroUnitCost: "Some items have zero unit cost. Please check again!",
    hasZeroQuantity: "Some items have zero quantity. Please check again!",
    hasZeroStockOnHand: "Some items have zero stock on hand. Please check again!",
    hasQtyGreatedThanStockOnHand: "Some items have quantity greater than stock on hand. Please check again!",
    rejectHeader: "Reject {f}",
    rejectAlready: "These item(s) already rejected:<br/>{f}",
    reject: "Are you sure you want to reject {f}?<br/>This process cannot be undone.",
    splitHeader: "Split {f}",
    splitSuccess: "Item has been split successfully!",
    splitFailed: "Error, cannot split item.<br/>{f}",
    splitMultipleFailed: "Error, cannot split more than one item.",
    setVendorSuccess: "{f} has been updated successfully!",
    cancelReceipt: "Are you sure you want to cancel receipt {f}? This process cannot be undone.",
    cancelReceiptSuccess: "{f} has been canceled successfully!",
    cancelReceiptFailed: "Error, cannot cancel {f}.",
    cancelReceiptHeader: "Cancel Receipt {f}",
    undoReceipt: "Are you sure you want to undo receipt {f}? This process cannot be undone.",
    undoReceiptSuccess: "Undo {f} success!",
    undoReceiptFailed: "Error, cannot undo {f}.",
    undoReceiptHeader: "Undo Receipt {f}",
    forceCloseHeader: "Force Close {f}",
    forceClose: "Are you sure you want to force close {f1} rows of {f2}? This process cannot be undone.",
    addfromReceiptSuccess: "{f} has been added succesfully with {d} duplicate found",
    incompleteSearch: "{f} need location or item filter",
    postedFailedNoItems: "Error, cannot post {f}. Must have at least 1 item to be received.",
    postFailedNoItems: "Error, cannot post {f}. Must have at least 1 item on the document.",
    updateFailedOnUnitEmpty: "Error, cannot save {f1}.<br/>These item(s) has no Unit of Measurement:<br/>{f2}",
    printFailedNoActiveFlow: "Error, cannot print this document.<br/>No Active Document Flow configured on batch {f}.",
    deleteFailedAlreadyReleased: "Error, cannot delete {f}.<br/>This document already released.",
    processToPoFailedOnVendorEmpty: "Cannot continue the process to Purchase Order. Please fill the purchase request line completely.",
    invalidAmount: "Error, invalid amount for apply entries",
    postedFailedNoItemsOnTable: "Error, cannot post batch {f}. Must have at least 1 document on table.",
    postBatchCompleted: "Post Batch completed!",
    failedDocumentToPost: "Some document failed to post:<br/>{f}",
    deleteAllSelected: "Are you sure you want to delete all selected items? This process cannot be undone.",
    deleteFailedNoItemsSelected: "Error, cannot delete {f}. Must have at least 1 selected item on table.",
    deleteFailedNoItems: "Error, cannot delete {f}. Must have at least 1 item on table.",
    setVendorFailedNoItemsSelected: "Error, cannot Set Vendor. Must have at least 1 selected item on table.",
    deleteFailedForStatus: "Error, cannot delete {f1}. {f2} already {f3}.",
    deleteItemFailedForStatus: "Error, cannot delete items. Item status already changed.",
    processedItemsStatus: "- {f1} ({f2}) {f3} {f4} => <b>{f5}</b>",
    reopenFailedProcessedAlready: "Some of the items have been processed. Can't Reopen!",
    postBatchConfirm: "Are you sure you want to post all data on table?",
    postSelectedConfirm: "Are you sure you want to post selected document?",
    noItemSelected: "Error, no item selected",
    postSRFailedPostingDateLessThanDocumentDate: "Error, cannot post {f}. Posting date can't be before document date.",
    setAllQtyToZero: "Are you sure you want to set all quantity to zero? This process cannot be undone.",
    updateLocationHeader: "Update Item Location",
    updateLocation: "Do you want to update all location in line into {f}?<br/>This process cannot be undone.",
    setLocationSuccess: "Item location has been updated successfully!",
    allQtyToZeroSuccess: "All quantity has been set to zero successfully!",
    allQtyToZeroFailed: "Error, cannot set all quantity to zero!",
    refreshPhysInvUnitCost: "Are you sure you want to refresh all unit cost? This process cannot be undone.",
    refreshPhysInvUnitCostSuccess: "All unit cost has been updated successfully!",
    refreshPhysInvUnitCostFailed: "Error, cannot refresh unit cost!",
    itemMassRecalculate: "Are you sure you want to recalculate all selected item unit cost? This process cannot be undone.",
    storeRequisitionRefreshUnitCost: "¿Está seguro de que desea recalcular todos los artículos y actualizar todos los costos unitarios para todas las líneas en este documento? Este proceso no se puede deshacer.",
    revertPostedStoreRequisition: "¿Está seguro de que desea revertir esta requisición de almacén publicada? Este proceso eliminará todas las entradas relacionadas con este documento y revertirá la SR al estado liberado nuevamente. Este proceso no se puede deshacer.",
    revertPostedStoreRequisitionSuccess: "La solicitud de almacén publicada se ha revertido con éxito.",
    revertPostedStoreRequisitionFailed: "Error, no se puede revertir la solicitud de almacén publicada.",
    deleteItemLedgerEntry: "¿Está seguro de que desea eliminar esta entrada del libro mayor de artículos? Este proceso eliminará todas las entradas relacionadas con este documento. Este proceso no se puede deshacer.",
    deleteItemLedgerEntrySuccess: "¡La entrada del libro mayor de artículos ha sido eliminada con éxito!",
    deleteItemLedgerEntryFailed: "Error, ¡no se puede eliminar la entrada del libro mayor de artículos!",
    deleteItemLedgerEntryTypeNotAllowed: "Este tipo de entrada no está permitido eliminarla.",
    itemMassRecalculateSuccess: "All unit cost has been recalculated!",
    itemMassRecalculateFailed: "Error, recalculate unit cost failed!",
    itemMassRecalculateNoData: "Recálculo de artículo no ejecutado, ¡no se encontraron datos!",
    refreshUnitCostSuccess: "¡Todos los costos unitarios han sido actualizados!",
    refreshUnitCostFailed: "Error, ¡no se pueden actualizar los costos unitarios!",
    itemTypeIsNotGl: "Item type is not allowed",
    withdrawHeader: "Withdraw {f}",
    withdraw: "Are you sure you want to withdraw {f}? This process cannot be undone.",
    withdrawSuccess: "{f} has been withdrawn successfully!",
    delegateSuccess: "{f} has been delegated successfully!",
    delegate: "Are you sure you want to delegate <strong>{t}</strong> on behalf of <strong>{f}</strong>? The involved users will be notified.",
    delegateHeader: "Delegate {t}",
    viewReportFailedNoSetup: "Cannot view report due to some missing entry on Inventory Reconciliation Setup.<br/>Please complete all setup first!",
    approvalSubmissionSuccess: "{f} has been successfully submitted for approval!",
    entryEditorSuccess: "Entry has been successfully updated!",
    removeApplyToJournalIdAndAmountToApplyWithId: "Remove Applied Journal on ID : {f}",
    removeApplyToJournalIdAndAmountToApplyFailed: "Error, cannot remove {f}. The Journal ID still exist.",
    removeApplyToJournalIdAndAmountToApplyErrorFailed: "Error, remove applied journal failed",
    removeApplyToJournalIdAndAmountToApplyErrorCheckJournal: "Error, cannot remove because of error on check journal",
    removeApplyToJournalIAndAmountToApplydNotAllowed: "Remove Applied Journal not allowed",
    submitSuccess: "{f} has been submitted successfully!",
    withdrawDocument: "Are you sure you want to withdraw the document? This process cannot be undone.",
    adjustAllConfirmation: "Are you sure want to adjust all items?<br/>This process cannot be undone.",
    adjustConfirmation: "Are you sure want to adjust on filtered items only?<br/>This process cannot be undone.",
    viewReportFailedNoAccountSetup: "No se puede ver el informe. Debe tener al menos una o más cuentas configuradas.!",
    defaultDirectExpenseChanged: "Default direct expense is changed",
    overwriteDirectExpenseLineConfirm: "Do you want to overwrite all the line with new default?",
    existingLineRemovalConfirm: "The existing line will be removed. Are you sure?",
    undoForceCloseHeader: "Undo Force Close {f}",
    undoForceClose: "Are you sure you want to undo force close this item?",
    undoForceCloseFailed: "Cannot undo, some items are not force closed yet!",
    errorEmptyLines: "Las líneas no pueden estar vacías",
    failedGetSOHForItem: "Error, cannot get Stock On Hand for this Line/Item",
    invalidThresholdItems: "- {f1} ({f2}), unit cost {f3} with last direct cost {f4}",
    filteringWillBeReleased: "Se eliminarán todas las condiciones de filtrado, por lo que se procesarán todos los elementos. ¿Estás seguro?",
    areYouSure: "Estas segura?",
    setToCompletelyReceivedConfirmation: "¿Está seguro de que quiere establecer esto como completamente recibido?",
    unsetCompletelyReceivedConfirmation: "¿Está seguro de que quiere desactivar el estado de completamente recibido?",
    closeIncomeStatementSuccess: "Las entradas del diario del estado de resultados se han creado con éxito. Consulte los diarios creados en el lote especificado.",
    closeIncomeStatementFailed: "Error, fallo en la creación del diario de estado de ingresos",
    confirmAction: "Confirmar acción",
    areYouSureToAction: "¿Estás seguro de que quieres {action}?",
    costsUpdated: "¡Los costos de los artículos se han actualizado con éxito!",
    costsUpdateFailed: "Error, no se pueden actualizar los costos del artículo.",
    incorrectCostsWarning: "Los siguientes artículos tienen costos unitarios que difieren de sus costos de inventario. Puede cancelar o actualizar todos los costos unitarios automáticamente.",
    incorrectCostsTitle: "Artículos con costos incorrectos",
    incorrectCostsContinueAnyway: "Continuar de todos modos",
    incorrectCostsUpdate: "Actualizar costo unitario",
    incorrectCostsItemCode: "Código de artículo",
    incorrectCostsLocation: "Ubicación",
    incorrectCostsCurrentUnitCost: "Costo Unitario Actual",
    incorrectCostsStockOnHandCost: "Costo de Inventario Disponible",
    incorrectCostsDifference: "Diferencia",
    incorrectCostsStockOnHand: "Stock Disponible",
    confirmDelete: "¿Estás seguro de que deseas eliminar este {f}?",
    confirmDeleteMultiple: "¿Estás seguro de que deseas eliminar estos {f}?",
    setVatFailedNoItemsSelected: "Error, no se puede establecer el IVA. Debe haber al menos 1 artículo seleccionado en la tabla.",
    confirmUpdate: "¿Estás seguro de que deseas actualizar este {f}?",
    postSelectedConfirmWithCount: "¿Estás seguro de que deseas publicar los {v} documentos seleccionados?",
    confirmSendEmail: "¿Está seguro de que desea enviar correos a las facturas seleccionadas?",
    updatePurchaseOrderStatusConfirmation: "¿Estás seguro de cambiar el estado de '{f1}' a '{f2}'?",
    updatePurchaseOrderStatusConfirmationWithDoc: "¿Está seguro de que desea cambiar el estado de la Orden de Compra '{f1}' de '{f2}' a '{f3}'?",
    updateUnitCostVendorComparisonLowestSuccess: "{f} se ha actualizado con el precio más bajo usando comparación de proveedores!",
    updateUnitCostVendorComparisonLowestFailed: "Error, no se puede actualizar el costo unitario usando el precio de comparación del proveedor (más bajo).",
    successRecalculateInventory: "¡El Diario de Inventario Físico ha sido recalculado!",
    failedRecalculateInventory: "Error, no se puede recalcular el Diario de Inventario Físico.",
    revertSuccess: "{f} ha sido revertido con éxito!",
    revertFailed: "Error, no se puede revertir {f}.",
    dimensionBulkImportSuccess: "{dimensiones} dimensiones añadidas, {valores} valores añadidos",
    coaDimensionBulkImportSuccess: "{mappings} mapeos añadidos, {rules} reglas añadidas",
    updateCoaDimensionMappingConfirmation: "¿Está seguro de que desea actualizar este mapeo?",
    downloadFailedActiveFlowIsEmpty: "Error, no se puede descargar este documento.<br/>El flujo de documentos activo actual no está configurado o aún está vacío.",
    calculateInventoryFilterWarning: "Si se utiliza el filtro a continuación, el cálculo de inventario creará una nueva entrada en lugar de sobrescribir la existente.",
    processExpiredWarning: "¿Estás seguro de que quieres caducar entradas antiguas? Las entradas de más de {x} se marcarán como caducadas. Esta acción se puede revertir, pero solo manualmente por entrada.",
    forceCloseWarning: "¿Está seguro de que desea cerrar forzosamente las entradas antiguas? Todas las entradas mayores a {x} se cerrarán permanentemente. Esta acción no se puede deshacer.",
    revertExpiredWarning: "¿Estás seguro de que quieres revertir las entradas expiradas?",
    addfromReceiptRejected: "{f} línea(s) rechazadas: {m}",
    postPositiveAdjustmentNotAllowed: "No se puede publicar: ajuste positivo no permitido para {f}.",
  },
  data: {
    clientLedgerEntryId: "Id de Entrada de Libro Mayor del Cliente",
    vendorLedgerEntryId: "Id de Entrada de Libro Mayor del Proveedor",
    isReconciled: "Está Reconciliado",
    isCloseYearEntry: "Es Entrada de Cierre de Año",
    stockOnHand: "Inventario Disponible",
    inputStockOnHand: "Input Inventario Disponible",
    inputStockOnHandFrom: "Input Inventario Disponible (Desde)",
    inputStockOnHandTo: "Input Inventario Disponible (Hasta)",
    stockOnHandFrom: "Inventario Disponible (Desde)",
    stockOnHandTo: "Inventario Disponible (Hasta)",
    reconciliationGlAccount: "Cuenta GL Predeterminada",
    virtualAccount: "Cuenta Virtual",
    accountName: "Nombre de la Cuenta",
    accountNameList: "Lista de nombres de cuenta",
    accountNumber: "Número de Cuenta",
    bankAccountPostingGroupCode: "Código del Grupo de Registro de Cuenta Bancaria",
    bankAccountPostingGroupName: "Nombre del Grupo de Registro de Cuenta Bancaria",
    reconciliationAccount: "Cuenta de Reconciliación",
    reconciliationBankAccount: "Cuenta Bancaria de Reconciliación",
    isReconciliationAccount: "Es Cuenta de Reconciliación",
    showOppositeSigninReport: "Mostrar Signo Opuesto en Informe",
    setWidenedPhysicalInventoryRow: "Establecer Fila de Inventario Físico Ampliado",
    itemVendorPurchaseprice: "Precio de Compra del Proveedor del Artículo",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Finalización",
    startDateWithPlaceholderDDMMYYYY: "Fecha de Inicio (DD-MM-YYYY)",
    endDateWithPlaceholderDDMMYYYY: "Fecha de Finalización (DD-MM-YYYY)",
    purchasePrice: "Precio de Compra",
    year: "Año",
    lastIleId: "Último Id de ILE",
    inventoryPostingType: "Tipo de Publicación de Inventario",
    isFlashCostStoreRequisition: "Es Requisición de Coste Flash de Almacén",
    isFlashCostPurchaseRequisition: "Es Requisición de Compra de Coste Flash",
    requestStatus: "Estado de la Solicitud",
    receiptStatus: "Estado de Recepción",
    created: "Creado",
    createdBy: "Creado por",
    createdAt: "Creado en",
    lastModified: "Última Modificación",
    lastModifiedBy: "Última Modificación por",
    swiftCode: "Código SWIFT",
    defaultBank: "Cuenta por Defecto",
    destinationName: "Destino",
    department: "Departamento",
    clientInfo: "Información del Cliente",
    clientCode: "Código del Cliente",
    clientName: "Nombre del Cliente",
    clientId: "ID del Cliente",
    guestName: "Nombre del Huésped",
    appliedVendorLedgerEntryId: "ID Aplicado",
    appliedClientLedgerEntryId: "ID Aplicado",
    defaultGuestInhouseAccountId: "Cuenta por Defecto del Huésped en Casa",
    isReceivedCompletely: "Recepción Completa",
    termCode: "Código del Término",
    termName: "Nombre del Término",
    searchBar: "Busca algo aquí...",
    netChange: "Cambio Neto",
    entry: "Entrada",
    totalDocument: "Documento Total",
    vendorCode: "Código del Proveedor",
    vendorName: "Nombre del Proveedor",
    itemCode: "Código del Artículo",
    itemName: "Nombre del Artículo",
    itemID: "ID del Artículo",
    itemTypeName: "Nombre del tipo de artículo",
    itemTypeID: "Item Type ID",
    itemDescription: "ID del tipo de artículo",
    itemUnitCost: "Costo unitario del artículo",
    vatAmount: "Monto del IVA",
    autoRecalculateCost: "Recalcular Coste Automáticamente",
    step: "Paso",
    allowMultiple: "Permitir Múltiples",
    posting: "Publicación",
    invoice: "Factura",
    receipt: "Recibo",
    detail: "Detalle",
    receiptPosting: "Publicación de Recibo",
    splitVendorDescription: "Dividir descripción del proveedor",
    order: "Pedido",
    wording: "Redacción",
    defaultName: "Nombre por Defecto",
    defaultRoleName: "Nombre de Rol por Defecto",
    role: "Rol",
    no: "No",
    defaultVatProductPostingGroup: "Grupo de Publicación de Producto IVA por Defecto",
    code: "Código",
    name: "Nombre",
    conversion: "Conversión",
    description: "Descripción",
    email: "Correo Electrónico",
    accountNo: "Número de Cuenta",
    glAccount: "Cuenta G/L",
    glAccountNo: "Número de Cuenta G/L",
    location: "Ubicación",
    offsetLocation: "Ubicación de compensación",
    defaultFromLocation: "Ubicación por Defecto Desde",
    defaultToLocation: "Ubicación por Defecto Hasta",
    invPostGroup: "Grupo de Publicación de Inv.",
    accountCode: "Código de Cuenta",
    interimAccountName: "Cuenta Provisional",
    interimAccountNo: "Número de Cuenta Provisional",
    purchaseAccount: "Cuenta de Compra",
    accrualInterimAccount: "Cuenta Provisional de Acumulación",
    inventoryAdjustmentAccount: "Cuenta de Ajuste de Inventario",
    expenseInventoryAdjustmentAccount: "Cuenta de Ajuste de Inventario de Gastos",
    directCostAppliedAccount: "Cuenta de Coste Directo Aplicado",
    vatProductPostingGroup: "Grupo de Publicación de Producto IVA",
    vatProductPostingGroupID: "ID de Grupo de Publicación de Producto IVA",
    vatBusPostGroup: "Grupo de Publicación de IVA de Negocios",
    vatBusPostGroupCode: "Código de Grupo de Publicación Comerciales Gen",
    vatBusPostGroupID: "ID de Grupo de Publicación Comerciales Gen",
    whtVatProductPostingGroup: "Grupo de Publicación de IVA WHT",
    genBusPostGroup: "Grupo de Publicación General de Negocios",
    genBusPostGroupCode: "Código de Grupo de Publicación Comerciales Gen",
    genBusPostGroupID: "ID de Grupo de Publicación General de Negocios",
    genProdPostGroup: "Grupo de Publicación General de Productos",
    genProdPostGroupID: "ID de Grupo de Publicación General de Productos",
    bankAccPostGroup: "Grupo de Publicación de Cuenta Bancaria",
    paymentTerm: "Término de Pago",
    directExpenseGenBusPostGroup: "Grupo de Publicación General de Gastos Directos de Negocios",
    directExpenseGenProdPostGroup: "Grupo de Publicación General de Gastos Directos de Productos",
    directExpenseAdjustmentAccount: "Cuenta de Ajuste de Gastos Directos",
    defaultDirectExpenseGenBusPostGroup: "Grupo de Publicación General de Gastos Directos de Negocios por Defecto",
    custPostGroup: "Grupo de Publicación de Clientes",
    vendorPostGroup: "Grupo de Publicación de Proveedores",
    journalTemplate: "Plantilla de Diario",
    journalTemplateId: "ID de Plantilla de Diario",
    journalBatchId: "ID de Lote de Diario",
    revenueLineId: "ID de línea de ingresos",
    noSeries: "Número de Serie",
    defaultLocation: "Ubicación por Defecto",
    prefix: "Prefijo",
    startingNumber: "Número Inicial",
    lastNumberUsed: "Último Número Usado",
    lengthOfNumber: "Longitud del Número",
    includeYear: "Incluir Año",
    includeMonth: "Incluir Mes",
    includeDate: "Incluir Fecha",
    isEditable: "Es Editable",
    branch: "Sucursal",
    bankAccountNo: "Número de Cuenta Bancaria",
    virtualAccountNo: "Número de Cuenta Virtual",
    allowPostingFrom: "Permitir Publicación Desde",
    allowPostingTo: "Permitir Publicación Hasta",
    receivableAccount: "Cuenta por Cobrar",
    receivableAccountNo: "Número de Cuenta por Cobrar",
    payableAccount: "Cuenta por Pagar",
    balanceAccount: "Cuenta de Saldo",
    accountCategory: "Categoría de Cuenta",
    accountType: "Tipo de Cuenta",
    directPost: "Publicación Directa",
    blocked: "Bloqueado",
    vatPercentage: "Porcentaje de IVA",
    startingDate: "Fecha de Inicio",
    closed: "Cerrado",
    endingDate: "Fecha de Finalización",
    dueDateCalc: "Cálculo de Fecha de Vencimiento",
    address: "Dirección",
    city: "Ciudad",
    country: "País",
    phoneNo: "Teléfono",
    contactName: "Nombre del Contacto",
    unit: "Unidad",
    costingMethod: "Método de Costeo",
    unitCost: "Costo Unitario",
    baseUnitCost: "Básica Costo Unitario",
    inputUnitCost: "Input Costo Unitario",
    lastDirectCost: "Último Costo Directo",
    reorderQuantity: "Cantidad de Reorden",
    totalling: "Totalizando",
    totallingFrom: "Totalizando Desde",
    totallingTo: "Totalizando Hasta",
    directPosting: "Publicación Directa",
    batch: "Lote",
    batchName: "Nombre del Lote",
    lineNo: "Número de Línea",
    postingDate: "Fecha de Publicación",
    documentNo: "Número de Documento",
    isApplied: "Está Aplicado",
    amount: "Monto",
    debitAmount: "Monto Débito",
    creditAmount: "Monto Crédito",
    inventory: "Inventario",
    vendorAccount: "Cuenta del Proveedor",
    clientAccount: "Cuenta del Cliente",
    totalAmount: "Monto Total",
    selectedTotalAmount: "Monto Total Seleccionado",
    status: "Estado",
    purchasingStatus: "Estado de Compra",
    expectedDate: "Fecha Esperada",
    quantity: "Cantidad",
    inputQuantity: "Input Cantidad",
    inputUom: "UdM de Entrada",
    forceCloseReason: "Motivo de Cierre Forzado",
    unitPrice: "Precio Unitario",
    totalPrice: "Precio Total",
    closedByUser: "Cerrado Por Usuario",
    includeAutoClosed: "Incluir Cerrados Automáticamente",
    baseQuantity: "Básica Cantidad",
    id: "ID",
    orderDate: "Fecha del Pedido",
    amountIncVat: "Monto Inc. IVA",
    itemNo: "Número de Artículo",
    purchaseRequestNo: "Número de PR",
    purchaseOrderNo: "Número de PO",
    deliveryDate: "Fecha de Entrega",
    quantityOutstanding: "Cantidad Pendiente",
    type: "Tipo",
    balance: "Saldo",
    balanceToDate: "Saldo a la Fecha",
    subTotal: "Subtotal",
    vat: "IVA",
    totalIncVat: "Total Inc. IVA",
    vendorDeliveryNo: "Número de Entrega del Proveedor",
    poNo: "Número de PO",
    salesTaxAccount: "Cuenta de Impuesto sobre Ventas",
    purchaseTaxAccount: "Cuenta de Impuesto sobre Compras",
    total: "Total",
    totalRows: "Total de Filas:",
    purchaseRequestSeries: "Serie de Solicitudes de Compra",
    purchaseOrderSeries: "Serie de Pedidos de Compra",
    purchaseReceiptSeries: "Serie de Recibos de Compra",
    purchaseInvoiceSeries: "Serie de Facturas de Compra",
    purchaseInvoiceLabel: "Etiqueta de Factura de Compra",
    purchaseReceiptLabel: "Etiqueta de Recibo de Compra",
    purchaseCreditMemoSeries: "Serie de Notas de Crédito de Compra",
    salesInvoiceSeries: "Serie de Facturas de Venta",
    salesCreditMemoSeries: "Serie de Notas de Crédito de Venta",
    receivableInvoiceSeries: "Serie de Facturas por Cobrar",
    symbol: "Símbolo",
    transferOrderSeries: "Serie de Orden de Transferencia",
    defaultCostingMethod: "Método de Costeo Predeterminado",
    quantityReceived: "Cantidad Recibida",
    quantityInvoiced: "Cantidad Facturada",
    quantityPO: "Cantidad Pedida",
    quantityToReceive: "Cantidad a Recibir",
    quantityOrdered: "Cantidad Pedida",
    purchaseReceivingList: "Lista de Historial de Recepciones de Compra",
    quantityToInvoice: "Cantidad a Facturar",
    prNumber: "Número de Solicitud de Compra",
    vendorOneName: "Proveedor 1",
    vendorOnePrice: "Precio 1",
    vendorTwoName: "Proveedor 2",
    vendorTwoPrice: "Precio 2",
    vendorThreeName: "Proveedor 3",
    vendorThreePrice: "Precio 3",
    showVendorColumns: "Mostrar Columna de Comparación de Proveedores",
    showVendorDetail: "Mostrar Proveedor",
    showSOHByInputUOM: "Mostrar Stock Disponible por Unidad de Medida de Entrada",
    showByInputUOM: "Mostrar Unidad de Medida de Entrada",
    expirationDate: "Fecha de Expiración",
    vendorInvoiceNo: "Número de Factura del Proveedor",
    receiptNo: "Número de Recibo",
    invoiceNo: "Número de Factura",
    sourcePurchaseInvoice: "Factura de Compra Origen",
    targetPurchaseInvoice: "Factura de Compra Destino",
    movePreview: "Vista Previa del Movimiento",
    from: "Desde",
    to: "Hacia",
    dueDate: "Fecha de Vencimiento",
    documentFlow: "Flujo de Documento Activo",
    receivableInvoiceDocumentFlow: "Flujo de Documento Activo de Factura por Cobrar",
    quantityToBeReceive: "Cantidad Restante por Recibir",
    purchaseRequisitionTemplate: "Plantilla de Requisición de Compra",
    entryType: "Tipo de Entrada",
    documentType: "Tipo de Documento",
    invoicedQuantity: "Cantidad Facturada",
    ileQuantity: "Cantidad ILE",
    ileBaseQuantity: "Básica Cantidad ILE",
    remainingQuantity: "Cantidad Restante",
    remainingQuantityToInvoice: "Restante para Facturar",
    outboundIle: "ILE Saliente",
    inboundIle: "ILE Entrante",
    costAmountExpected: "Monto de Costo Esperado",
    costAmountActual: "Monto de Costo Actual",
    valuationDate: "Fecha de Valoración",
    averageCostEntryType: "Tipo de Entrada de Costo Promedio",
    glRegisterId: "ID de Registro GL",
    sourceIdtDocumentNo: "N.º de Documento IDT de Origen",
    reconciledGlRegisterId: "Conciliado por ID de Registro GL",
    isAdjustment: "Es Ajuste",
    valuedQuantity: "Cantidad Valuada",
    applyToEntry: "Aplicar a Número de Entrada",
    fixedApply: "Aplicar Fijo",
    removeApplyToJournalIdAndAmountToApply: "Eliminar Diario Aplicado",
    applyToJournalIdAndAmountToApply: "Aplicar a ID de Diario y Monto a Aplicar",
    applyToJournalId: "Aplicar a ID de Diario",
    amountToApply: "Monto a Aplicar",
    applied: "Aplicado",
    invoiceDate: "Fecha de Factura",
    remainingAmount: "Monto Restante",
    remainingAmountIncVat: "Monto Restante Inc. IVA",
    unapplied: "No Aplicado",
    unappliedById: "No Aplicado por ID",
    currencyCode: "Código de Moneda",
    reversed: "Revertido",
    reversedBy: "Revertido Por",
    open: "Abierto",
    vendorInfo: "Información del Proveedor",
    itemNotOnInventory: "Artículo no en Inventario",
    dateFilterStart: "Fecha de Inicio",
    dateFilterEnd: "Fecha de Fin",
    dateFilter: "Filtro de Fecha",
    locationFilter: "Filtro de Ubicación",
    batchFilter: "Filtro de Lote",
    itemFilter: "Filtro de Artículo",
    quantityPhysicalInventory: "Cantidad (Inventario Físico)",
    quantityCalculated: "Cantidad (Calculada)",
    documentDate: "Fecha del Documento",
    requestByUser: "Solicitado Por",
    fromLocation: "Desde",
    toLocation: "Hasta",
    postingUser: "Publicado Por",
    posted: "Publicado",
    isPosted: "Está Publicado",
    quantityShipped: "Cantidad Enviada",
    baseQuantityShipped: "Básica Cantidad Enviada",
    locationCode: "Código de Ubicación",
    locationName: "Nombre de Ubicación",
    chartOfAccountDetail: "Detalle del Plan de Cuentas",
    taxType: "Tipo de Impuesto",
    notAvailable: "No Disponible",
    notApplicable: "No Aplicable",
    appliesToPostedSalesInvoiceId: "ID de Factura de Venta Aplicada",
    appliesToPostedPurchaseInvoiceId: "ID de Factura de Compra Aplicada",
    appliesToPostedSalesCreditMemoId: "ID de Nota de Crédito de Venta Aplicada",
    cashDeskMovementId: "Id de Movimiento de Caja",
    isForceClosed: "Está Forzado a Cerrar",
    monthClosed: "Mes Cerrado",
    yearClosed: "Año Cerrado",
    inventoryClosed: "Inventario Cerrado",
    createYear: "Establecer para un año",
    includeIncome: "Incluir entrada de cierre",
    retainedEarningAccount: "Cuenta de Utilidades Retenidas",
    showQuantityCalculated: "Mostrar columna de Cantidad (Calculada)",
    showQuantityAdjusted: "Mostrar columna de Cantidad (Ajustada)",
    showAgedColumn: "Mostrar columna de Antigüedad",
    originalQuantity: "Cantidad Original",
    splitQuantity: "Cantidad a Dividir",
    appliesToInvoiceNo: "Aplica a Factura de Compra Publicada",
    appliesToSalesInvoiceNo: "Aplica a Factura de Venta Publicada",
    vendorId: "ID de Proveedor",
    itemJournalMasterTemplate: "Plantilla Maestra de Diario de Artículo",
    generalJournalMasterTemplate: "Plantilla Maestra de Diario General",
    checkIn: "Registro de Entrada",
    checkOut: "Registro de Salida",
    night: "noche",
    roomNo: "Número de Habitación",
    receivableInvoiceFooter: "Pie de Página de Factura por Cobrar",
    receivableInvoiceHeader: "Encabezado de Factura por Cobrar",
    allowBiggerQuantityInPurchaseOrder: "Permitir Mayor Cantidad en la Orden de Compra",
    defaultPrintPOGroupLocation: "Agrupado por ubicación de forma predeterminada al imprimir la orden de compra",
    footerAutoColumn: "Columna automática de pie de página",
    allowAddNewItemInPOFromPR: "Permitir añadir nuevo artículo en la OC desde PR",
    allowFlexibleItemInPO: "Permitir flexibilidad en el artículo de la OC (manual y artículo PR)",
    allowChangePriceWhenPOIsReleased: "Permitir cambio de precio cuando la OC esté liberada",
    useCompanyNameForPrintout: "Usar Nombre Legal de la Empresa en el encabezado de impresión",
    useBrandHotelNameForPrintout: "Usar Nombre de la Marca del Hotel en el encabezado de impresión",
    purchaseOrderFooter: "Pie de Página de Orden de Compra",
    customFooterPurchaseOrderText: "Texto Personalizado del Pie de Página de Orden de Compra",
    customFooterPurchaseRequestText: "Texto Personalizado del Pie de Página de Solicitud de Compra",
    customFooterPurchaseInvoiceText: "Texto Personalizado del Pie de Página de Factura de Compra",
    customFooterPurchaseReceiptText: "Texto Personalizado del Pie de Página de Recibo de Compra",
    customFooterStoreRequisitionText: "Texto Personalizado del Pie de Página de Solicitud de Tienda",
    lastPrice: "Último Precio",
    baseLastPrice: "Último Básica Precio",
    isFreeOfCharge: "Es Gratuito",
    defaultFOCashDesk: "Caja de FO Predeterminada",
    defaultFOCollectionType: "Tipo de Recaudación FO Predeterminado",
    documentTitle: "Título del Documento",
    startPostingDate: "Fecha de Inicio de Publicación",
    endPostingDate: "Fecha de Fin de Publicación",
    allVendors: "Todos los Proveedores",
    allGroups: "Todos los Grupos",
    inventoryGroup: "Grupo de Inventario",
    noteCurrency: "Nota: La moneda utilizada en este informe es {f}",
    otaBookingId: "ID de Reserva OTA",
    otaBookingClientPostingGroup: "Grupo de Publicación de Cliente para Mostrar ID de Reserva OTA",
    show: "Mostrar",
    all: "Todos",
    fromAccount: "Desde Cuenta",
    toAccount: "Hasta Cuenta",
    noteAccountFromTo: "Nota: Este informe será filtrado desde la cuenta <strong>{f1}</strong> hasta <strong>{f2}</strong>",
    showDetail: "Mostrar Detalle",
    showAllAccounts: "Mostrar Todas las Cuentas",
    agedAsOfThisDate: "Antigüedad a partir de esta fecha",
    grandTotal: "Total General",
    receivableNo: "Número por Cobrar",
    showAllClients: "Mostrar Todos los Clientes",
    copiedToClipboard: "¡Copiado al portapapeles!",
    sortOrder: "Orden de Clasificación",
    setAppliesTo: "Establecer aplica a: {f}",
    date: "Fecha",
    hotelName: "Nombre del Hotel",
    source: "Fuente",
    days130: "1-30 Días",
    days3160: "31-60 Días",
    days6190: "61-90 Días",
    days91120: "91-120 Días",
    days120: ">120 Días",
    periodLabel: "{d1} a {d2}",
    downloadGSheet: "Descargar GSheet",
    downloadExcel: "Descargar Excel",
    downloadPDF: "Descargar PDF",
    report: "Informe",
    period: "Período",
    group: "Grupo",
    totalCost: "Costo Total",
    totalCostAdjust: "Costo Total",
    totalAdjustment: "Ajuste Total",
    lineStatus: "Estado de la Línea",
    useSystematicApproval: "Usar Aprobación Sistemática",
    itemType: "Tipo de Artículo",
    article: "Artículo",
    articleType: "Tipo de Artículo de Venta",
    baseSellingPrice: "Precio de Venta Base",
    costPercentage: "Costo %",
    headerNoSeries: "Serie de Cabecera",
    lineNoSeries: "Serie de Línea",
    lineDocumentNo: "No. Documento de Línea",
    outlet: "Punto de Venta",
    setDefaultDirectExpense: "Establecer Gasto Directo Predeterminado",
    notesOrReason: "Notas / Razón",
    user: "Usuario",
    approved: "Aprobado",
    rejected: "Rechazado",
    declined: "Declinado",
    preparedBy: "Preparado Por",
    checkedBy: "Revisado Por",
    approvedBy: "Aprobado Por",
    approverName: "Nombre del Aprobador",
    sequence: "Secuencia",
    flowOrder: "Orden de Flujo",
    priority: "Prioridad",
    defaultPurchaseRequestPriority: "Prioridad de Solicitud de Compra Predeterminada",
    earliest: "Más Temprano",
    latest: "Más Reciente",
    showSummary: "Mostrar Resumen",
    delegatedTo: "Delegado A",
    footerText: "Texto del Pie de Página",
    formattingNotes: "Estas etiquetas de formato solo se pueden aplicar a cada línea: *negrita* _cursiva_",
    showHotelLogo: "Mostrar logo del hotel",
    showHotelAddress: "Mostrar dirección del hotel",
    food: "Comida",
    beverage: "Bebida",
    material: "Material",
    engineering: "Ingeniería",
    showEngineering: "Mostrar cuenta de Ingeniería en una pestaña separada",
    coaID: "ID de COA",
    addAccount: "Añadir Cuenta",
    selectAccountName: "Seleccionar Nombre de Cuenta",
    selectDimensionValue: "Seleccionar Valor de Dimensión",
    restore: "Restaurar",
    setToNonDirectExpense: "Establecer como Gasto No Directo",
    includeApprovalNotes: "Incluir Notas de Aprobación",
    reviewedBy: "Revisado Por",
    reviewedAt: "Revisado En",
    delegatedAt: "Delegado En",
    delegatedFrom: "Delegado Desde",
    isOpen: "Está Abierto",
    showAllItems: "Mostrar Todos los Artículos",
    hideUnopenedItems: "Ocultar Artículos No Abiertos",
    showAllBanks: "Mostrar Todos los Bancos",
    creditAccount: "Cuenta de Crédito",
    debitAccount: "Cuenta de Débito",
    totalCredit: "Total Crédito",
    totalDebit: "Total Débito",
    totalLedger: "Total Libro Mayor",
    totalPayment: "Total Pago",
    summary: "Resumen",
    hideAmountInPurchaseRequestPrintout: "Ocultar Monto en Impresión de Solicitud de Compra",
    showTotalCostInPurchaseRequestPrintVendorComparison: "Mostrar Costo Total en Comparación de Proveedores de Solicitud de Compra",
    enableDescriptionCopyToRemark: "Habilitar la copia de la descripción en el comentario de la solicitud de compra",
    allowSOHZeroWhenStoreRequisitionIsSaved: "Permitir SOH Cero cuando la Solicitud de Almacén esté Guardada",
    allowRequestedQtyBiggerThanSoh: "Permitir cantidad solicitada mayor que existencias disponibles",
    useLastDirectCostWhenNoContract: "Usar último costo directo cuando no haya contrato",
    useLastDirectCostWhenNoContractNote: "Al asignar un proveedor en una Solicitud de Compra Pendiente y el precio de contrato no está disponible, se sobrescribirá la entrada del usuario y se utilizará el último costo directo (Esto también se aplica para la Orden de Compra)",
    itemCodeGeneratedBySystem: "El código del artículo será generado por el sistema",
    mdrFee: "Tasa de Descuento del Comerciante {f} (%)",
    batchHasMdrFee: "Lote <strong>{f}</strong> tiene opciones de Tasa de Descuento del Comerciante:",
    showZeroBalance: "Mostrar Saldo Cero",
    targetEntry: "Entrada Objetivo",
    approvalPrintout: "Impresión de Aprobación",
    document: "Documento",
    outstanding: "Pendiente",
    documentsSelected: "documento(s) seleccionado(s)",
    documentSelected: "documento seleccionado",
    defaultVendorSetup: "Configuración Predeterminada para Proveedor",
    defaultClientSetup: "Configuración Predeterminada para Cliente",
    defaultItemSetup: "Configuración Predeterminada para el Articulo",
    noVat: "Sin IVA",
    purchaseOrderDocumentFlow: "Flujo de Documentos de Orden de Compra",
    dailyMarketListDocumentFlow: "Flujo de Documentos de Lista de Mercado Diaria",
    remark: "Comentario",
    deleteRemark: "Eliminar Comentario",
    taxIdentificationNumber: "Número de Identificación Fiscal",
    attachment: "Adjunto",
    fileFormat: "Formato de Archivo",
    adjustAllItems: "Ajustar Todos los Artículos",
    adjustFilteredItems: "Ajustar Artículos Filtrados",
    adjustItem: "Ajustar Artículo",
    showItemDetail: "Mostrar Artículo",
    showClientDetail: "Mostrar Cliente",
    showPurchaseBook: "Mostrar Libro de Compras",
    queryDate: "Fecha de Consulta",
    queryAdjustmentDate: "Fecha de consulta y ajuste",
    adjustmentPostingDate: "Fecha de Publicación de Ajuste",
    valueEntryID: "ID de Entrada de Valor",
    costAmountAdjustment: "Ajuste del Monto de Costo",
    viewData: "Ver Datos",
    ileID: "ID de ILE",
    lastValueEntryID: "Último ID de Entrada de Valor",
    unitCostThreshold: "Umbral de costo unitario",
    unitCostThresholdUsingLastDirectCost: "Umbral de Costo Unitario usando el último costo directo",
    minUnitCost: "Costo Unitario Mínimo (%)",
    maxUnitCost: "Costo Unitario Máximo (%)",
    isReversed: "Está Reversado",
    reversedPostingDate: "Fecha de Publicación Reversa",
    descriptionForVendor: "Descripción (para Proveedor)",
    remarkInternalOnly: "Comentario de Compra (solo interno)",
    remarkInternalNoteForPurchasingOnly: "Comentario (nota interna solo para Compras)",
    isDirectExpense: "Es Gasto Directo",
    isDML: "Es DML",
    inputUOMID: "Input UdM ID",
    inputUOMCode: "Input UdM Code",
    inputUOMName: "Input UdM Name",
    transferOrder: "Orden de transferencia",
    negativeAdjustment: "Ajuste negativo",
    quantityEqualZero: "Cantidad = 0",
    quantityGreaterThanZero: "Cantidad > 0",
    costNegative: "Costo Negativo",
    groupByLocation: "Agrupar por ubicación",
    groupByVendor: "Agrupar por vendedor",
    showAllARCard: "Mostrar todas las tarjetas A/R",
    setToCompletelyReceived: "Marcar como Completamente Recibido",
    unsetCompletelyReceived: "Desmarcar Completamente Recibido",
    defaultChartOfAccount: "Plan de Cuentas Predeterminado",
    defaultCOAAmount: "Cantidad Predeterminada del Plan de Cuentas",
    defaultDescription: "Descripción Predeterminada",
    salesInvoiceNumberSeries: "Serie de Número de Factura de Venta",
    invoiceHeaderAddress: "Dirección del Encabezado de la Factura",
    openingInventory: "Inventario de apertura",
    incomingInventory: "Inventario entrante",
    closingInventory: "Inventario de cierre",
    inventoryAvailable: "Inventario disponible",
    grossConsumption: "Consumo Bruto",
    creditsConsumption: "Créditos - Consumo",
    creditsComplimentaryCost: "Créditos - Costo de cortesía",
    creditsInterDepartmentTransfer: "Créditos - Transferencia entre departamentos",
    otherAdjustment: "Otro ajuste",
    netConsumption: "Consumo Neto",
    netBeverageSales: "Ventas netas de bebidas",
    costOfSales: "Costo de ventas",
    debitCost: "Costo de débito",
    generalSetup: "Configuración General",
    onlyShowSameQuantity: "Mostrar solo la misma cantidad",
    excludedHotel: "Hotel Excluido",
    idExcludedAutomatically: "Los IDs por debajo de {item} están excluidos automáticamente",
    ileDocumentNo: "ILE Número de documento",
    businessRegistrationNumber: "Número de Registro Comercial",
    appliedInMalaysia: "Actualmente aplicado en Malasia",
    adjust: "Adjust",
    importFromExcel: "Importar desde Excel",
    chooseFile: "Seleccione Archivo",
    previewData: "Vista previa de datos",
    adjustingPleaseWait: "Ajustando, por favor espere...",
    excelFile: "Archivo Excel",
    showCoaDestination: "Mostrar destino del COA",
    defaultPrintShowCoaDestination: "Mostrar Destino de COA por Defecto en la Impresión",
    directExpense: "Gasto Directo",
    movementType: "Tipo de Movimiento",
    sohDate: "Fecha de SOH",
    revaluationJournal: "Revaluación Diario",
    revaluateCost: "Reevaluar Costo",
    purchaseCost: "Costo de Compra",
    getPurchaseCost: "Obtener Costo de Compra",
    valueEntriesToAdjust: "Entradas de Valor para Ajustar",
    getValueEntriesToAdjust: "Obtener Entradas de Valor para Ajustar",
    processAdjustment: "Procesar Ajuste",
    updateUnitCost: "Actualizar Costo Unitario",
    unitCostPurchase: "Costo Unitario de Compra",
    expectedTotalCost: "Costo Total Esperado",
    currentTotalCost: "Costo Total Actual",
    currentUnitCost: "Costo Unitario Actual",
    purchaseUnitCost: "Costo Unitario de Compra",
    diffUnitCost: "Diferencia en Costo Unitario",
    locationID: "ID de Ubicación",
    minimumCostDifference: "Diferencia de costo mínima",
    showInvoiceTaxBreakdown: "Mostrar desglose de impuestos en la factura",
    changeAppliedSalesInvoiceID: "Cambiar ID de Factura de Venta Aplicada",
    currentAppliedSalesInvoiceID: "ID Actual de Factura de Venta Aplicada",
    newAppliedSalesInvoiceID: "Nuevo ID de Factura de Venta Aplicada",
    changeAppliedID: "Cambiar ID Aplicado",
    taxNo: "No. de Impuesto",
    taxID: "ID Fiscal",
    showTaxForm: "Mostrar Formulario de Impuestos",
    taxNoLabel: "Etiqueta No. de Impuesto",
    taxIDLabel: "Etiqueta ID Fiscal",
    additionalTopMargin: "Margen Superior Adicional",
    additionalTopMarginHints: "Espacio adicional de margen superior para la impresión de facturas por cobrar",
    endingBalance: "Saldo final",
    ledgerMutation: "Mutación del libro mayor",
    display: "Mostrar",
    detailByDay: "Detalle por día",
    showPODetail: "Mostrar detalles",
    logNo: "Log No",
    itemJournalLogSeries: "Serie de registro de diario de artículos",
    printOptions: "Opciones de impresión",
    allowChangeUnitCostGreaterThanOriginal: "Permitir cambio de costo unitario mayor que el original",
    allowChangeUnitCostLessThanOriginal: "Permitir cambio de costo unitario menor que el original",
    actual: "Real",
    budget: "Presupuesto",
    deliveryNo: "Número de entrega",
    showVendorDeliveryNoOnPrintout: "Mostrar el número de entrega del proveedor en la impresión",
    amountWithCurrency: "Cantidad ({c})",
    balanceWithCurrency: "Balance ({c})",
    centerHotelLogo: "Mostrar el logotipo del hotel en el centro del papel.",
    businessRegistrationNumberNew: "Número de Registro Comercial (Nuevo)",
    businessActivityDescription: "Descripción de la Actividad Comercial",
    sstRegistrationNumber: "Número de Registro SST",
    msicCodeNumber: "Número de Código MSIC",
    msicDescription: "Descripción de MSIC",
    appliedBankAccountLedgerEntryId: "ID Aplicada",
    value: "Valor",
    amountExcVat: "Monto sin IVA",
    unitCostIncVat: "Coste Unitario con IVA",
    closeIncomeStatementJournalBatch: "Cerrar Lote de Diario de Estado de Resultados",
    reviewYtdReportComparisonYear: "Año de Comparación del Reporte YTD",
    witholdingTaxDefaultJournalBatch: "Batch de Diario de Retención de Impuestos",
    showAgingDays: "Mostrar Días de Antigüedad",
    coaApInterim: "COA AP Interino",
    defaultDirectExpenseItemJournalBatch: "Lote de Diario de Gastos Directos Predeterminado",
    summaryByLocation: "Resumen por Ubicación",
    netFoodSales: "Ventas Netas de Alimentos",
    inventoryAvailableFormula: "Apertura + Entrante + Débito",
    grossConsumptionFormula: "Disponible - Cerrando",
    otherAdjustmentFormula: "Consumo Bruto - Costo Complementario - Interdepartamental",
    journalDetail: "Detalles del Diario",
    documentStartDate: "Fecha de inicio del documento",
    documentEndDate: "Fecha de fin del documento",
    beginning: "Inicio",
    beginningQty: "Cantidad Inicial",
    beginningValue: "Valor Inicial",
    incomingQty: "Cantidad Entrante",
    outgoingQty: "Cantidad Saliente",
    endingQty: "Cantidad final",
    endingValue: "Valor Final",
    averagePrice: "Precio Promedio",
    receiptDate: "Fecha de recibo",
    aging: "Envejecimiento",
    showPostingDateColumn: "Mostrar columna de fecha de publicación",
    tin1Label: "Etiqueta TIN 1",
    tin1Value: "Valor TIN 1",
    tin2Label: "Etiqueta TIN 2",
    tin2Value: "Valor TIN 2",
    welcomeText: "Estimado/a,  \nGracias por elegir {h} - adjunto encontrará la siguiente factura:",
    totalBalance: "Saldo Total",
    showWithdrawApproval: "Mostrar Aprobación de Retiro",
    paidAmount: "Cantidad Pagada",
    remaining: "Restante",
    allowCreateNewSetPaymentJournal: "Permitir crear nuevo conjunto de diario de pagos",
    allowCreateNewSetCashReceiptJournal: "Permitir crear nuevo conjunto de diario de recibos de efectivo",
    journalNotAllowForDirectPosting: "Los diarios para {f} no están permitidos para publicación directa.",
    journalHasZeroValue: "Los diarios de {f} no tienen valor",
    journalNotBalanced: "Diarios para {f}, no balanceados",
    showPreviousMonthAdjustment: "Mostrar ajuste de meses anteriores",
    noDimensionValue: "(Sin dimensión)",
    isPreviousMonth: "Mes Anterior",
    showAdjustmentEntry: "Mostrar Entrada de Ajuste",
    adjustmentSource: "Fuente de Ajuste",
    distributeAmount: "Distribuir Monto",
    distributeAmountEnablement: "Agrega al menos una cuenta bancaria primero para habilitar esta opción",
    distributeAmountMessage: "Esto distribuirá automáticamente el monto total a la cuenta bancaria.",
    allowChangeItemLastDirectCost: "Permitir cambiar el último costo directo del artículo",
    allowDirectReleasePO: "Permitir Liberación Directa de PO",
    useSystematicApprovalDML: "Usar Aprobación Sistemática (DML)",
    allowFreeOfChargeOnDirectExpense: "Permitir sin cargo en gasto directo",
    statistic: "Estadística",
    chequeNumber: "Número de cheque",
    showSignatureOnApproval: "Mostrar firma en aprobación",
    setVatProduct: "Establecer IVA Producto",
    locations: "Ubicaciones",
    allLocations: "Todas las ubicaciones",
    itemCodeOrItemName: "Código de artículo o nombre de artículo",
    account: "Cuenta",
    onBehalfOfLabel: "En Nombre De",
    sendEmail: "Enviar correo",
    useHOAInvoice: "Usar factura de HOA",
    telephone: "Teléfono",
    mobilePhone: "Teléfono móvil",
    purchaseOrderNO: "Número de Orden de Compra",
    requestNo: "Núm. de Solicitud",
    costCenter: "Centro de Costo",
    tax: "Impuesto",
    loc: "Ubic",
    uom: "UdM",
    qty: "Qty\" in Spanish is \"Cant.",
    dis: "Dis",
    supplierAddress: "Dirección del proveedor",
    voucherNo: "Número de vale",
    refNo: "Ref No\" in Spanish is: \"Ref No",
    paymentDueDate: "Fecha de vencimiento del pago",
    bankCode: "Código Bancario",
    showAsGroup: "Mostrar como grupo {s}",
    showAllVendor: "Mostrar Todos los Proveedores",
    affectedData: "Datos afectados",
    newPostingDate: "Nueva Fecha de Publicación",
    hide: "Ocultar",
    destinationID: "ID de destino",
    endingNumber: "Número final",
    downloadPrintoutPDF: "Descargar PDF de impresión",
    taxNumberSeries: "Serie de Número de Impuesto",
    taxCompany: "Empresa de Impuestos",
    taxExpiryDate: "Fecha de vencimiento de impuestos",
    taxPhone: "Teléfono de Impuestos",
    taxEmail: "Correo de Impuestos",
    taxReceiptNo: "Recibo de Impuesto No.",
    unitNo: "Núm. de Unidad",
    unitOwnerName: "Nombre del Propietario de la Unidad",
    company: "Empresa",
    selectedItems: "Elementos seleccionados",
    hoaCompanyName: "Nombre de la empresa HOA",
    hoaRoomType: "Tipo de habitación HOA",
    hoaUnitNo: "Núm. de Unidad HOA",
    emailTemplate: "Plantilla de correo",
    salesInvoiceSendEmailTemplate: "Plantilla de correo electrónico de factura de ventas",
    templateVariables: "Variables de Plantilla",
    exampleTemplate: "Plantilla de Ejemplo",
    invoiceLabelSetup: "Configuración de Etiqueta de Factura",
    updatePurchaseOrderStatus: "Actualizar estado de la orden de compra",
    updatePurchaseOrderStatusDescription: "Seleccione un nuevo estado para la orden de compra del menú desplegable a continuación.",
    currentStatus: "Estado Actual",
    newStatus: "Nuevo Estado",
    preview: "Vista previa",
    sortBy: "Ordenar por",
    allowEditPurchaseRequestInApproval: "Permitir editar solicitud de compra en aprobación",
    allowEditPurchaseRequestInApprovalNote: "Solo los usuarios que NO están en la lista de aprobación pueden editar. Esto funciona junto con el permiso 'Permitir al usuario modificar PR en aprobación'.",
    processToPoCopyDescription: "Proceso para copiar descripción de PO",
    show0Quantity: "Mostrar 0 Cantidad",
    selectedLocations: "Ubicaciones seleccionadas",
    selectedInventoryPostingGroups: "Grupos de Publicación de Inventario Seleccionados",
    noItemsSelected: "Ningún elemento seleccionado",
    noLocationsSelected: "Ninguna ubicación seleccionada",
    noInventoryPostingGroupsSelected: "No se seleccionaron grupos de publicación de inventario",
    vendorSource: "Fuente del proveedor",
    downloadCSV: "Descargar CSV",
    delegatedBy: "Delegado Por",
    showCustomerAccountType: "Mostrar Tipo de Cuenta del Cliente",
    printGeneralLedgerInformationonPostedDocument: "Imprimir información del libro mayor en documento publicado",
    submittedAt: "Enviado el",
    submittedBy: "Enviado por",
    withdrawalAt: "Retiro en",
    withdrawalBy: "Retiro por",
    expectedDueDate: "Fecha Esperada / Fecha de Vencimiento",
    documentApprovalType: "Tipo de Aprobación de Documento",
    useExtendedPRDescriptionLength: "Usar longitud extendida de descripción PR (255 caracteres)",
    allowMultilineDescription: "Permitir descripción de varias líneas en PR/PO",
    showUpdateLowestCostVendorComparisonPurchaseRequest: "Mostrar comparación de proveedores de costo más bajo en la solicitud de compra",
    printPreview: "Vista previa de impresión",
    descriptionMultiLineHint: "Presiona Enter o escribe ; (punto y coma) para añadir una nueva línea",
    appliesToPostedPurchaseCreditMemoId: "ID de Nota de Crédito por Compra Aplicada",
    createPaymentJournal: "Crear Diario de Pagos",
    createCashReceiptJournal: "Crear Diario de Recibos de Efectivo",
    lockPostingDateTheSameAsWorkingDateInFO: "Bloquear fecha de publicación igual a fecha de trabajo en FO",
    lockPostingDateTheSameAsWorkingDateInFONote: "Para el Diario de Recepciones de Efectivo y el Diario de Conciliación de Cuentas",
    totaling: "Totalizando",
    defaultDimensionValue: "Valor de Dimensión Predeterminado",
    dimensionSetID: "ID de conjunto de dimensiones",
    dimensionName: "Nombre de Dimensión",
    dimensionCode: "Código de Dimensión",
    optionCode: "Código de opción",
    defaultValueCode: "Código de Valor Predeterminado",
    allowed: "Permitido",
    allowedValueCode: "Código de Valor Permitido",
    dimensionValueName: "Nombre del Valor de Dimensión",
    dimensionValueCode: "Código de Valor de Dimensión",
    selectAllowedDimensionValues: "Selecciona los valores de dimensión permitidos para esta dimensión",
    selectDimensionToViewAllowedValues: "Selecciona una dimensión para ver los valores permitidos",
    selectedValues: "Valores Seleccionados",
    showPositive: "Mostrar Positivo",
    showBankAccountOnPaymentListReport: "Mostrar cuenta bancaria en todos los informes de pagos",
    footerFontType: "Tipo de fuente del pie de página",
    standardFontHint: "Fuente estándar del sistema",
    monospaceFontHint: "Cada carácter, incluyendo letras, números y espacios, ocupa el mismo ancho horizontal.",
    signatureAlignment: "Alineación de Firma",
    allowEditReleasedPOLineZeroQtyReceived: "Permitir editar línea de PO abierta y liberada cuando la cantidad recibida sea cero",
    overridePrLineFromPo: "Anular línea de PR cuando se modifica la línea de PO",
    month1: "1 Mes",
    month2: "2 Meses",
    month3: "3 Meses",
    month4: "4 Meses",
    moreThan4Months: "> 4 Meses",
    printingDateTime: "Fecha y hora de impresión",
    disc: "Disco",
    allowDeletePrSourcedPoLine: "Permitir eliminación de líneas de PO de PR (revierte línea de PR a Abierto)",
    purchaseRequestExpiredRange: "Rango de Solicitud de Compra Expirada (días)",
    purchaseOrderExpiredRange: "Rango de Vencimiento de Orden de Compra (días)",
    enablePrintButtonForOnlyReleasedDocuments: "Habilitar botón de imprimir solo si el estado del documento es Liberado",
    currentDimensionSetID: "ID del conjunto de dimensiones actual",
    newDimensionSetID: "Nuevo ID de Conjunto de Dimensiones",
    lastMovement: "Último Movimiento",
    age: "Edad",
    soh: "SOH",
    changeGLAccount: "Cambiar Cuenta GL",
    postPurchaseInvoice: "Factura de Compra",
    draft: "Borrador",
    setZeroQuantityPhysicalAsBlank: "Dejar 0 Cantidad (Inventario Físico) en blanco",
    reviewPnlYtdSummaryComparisonYear: "Resumen de Ganancias y Pérdidas YTD Comparación Anual",
    reviewPnlYtdConsolidationComparisonYear: "Comparación de Consolidación de Pérdidas y Ganancias YTD",
    reviewBalanceSheetYtdSummaryComparisonYear: "Resumen de Balance General YTD Comparación Anual",
    taxRegisterNumber: "Número de Registro Fiscal",
    purchaseReceiptNo: "PR No.\" in Spanish is: \"N° de PR",
    purchaseReceiptPostingDate: "Fecha de publicación de PR",
    amountDue: "Cantidad a Pagar",
    periodDate: "Fecha del período",
    parafInitial: "Firma / Inicial",
    appliesToPostedPurchaseInvoiceNo: "Número de Factura de Compra Aplicada",
    showContactNameOnPrintSummary: "Mostrar nombre de contacto en resumen impreso",
    depositAccountCode: "Código de Cuenta de Depósito",
    depositAccountName: "Nombre de la Cuenta de Depósito",
    boDepositAccountCode: "Código de Cuenta de Depósito BO",
    boDepositAccountName: "Nombre de la Cuenta de Depósito BO",
    foDepositAccountNo: "Núm. de Cuenta de Depósito FO",
    foDepositAccountName: "Nombre de la Cuenta de Depósito FO",
    depositAccountPostingGroupCode: "Código de Grupo de Publicación de Cuenta de Depósito",
    depositAccountPostingGroupName: "Nombre del Grupo de Publicación de Cuenta de Depósito",
    appliedDepositAccountLedgerEntryId: "ID Aplicada",
    showInDocument: "Mostrar en Documento",
    showInDocumentHint: "Los niveles marcados Mostrar en Documento añaden sus columnas de Código y Nombre a: Solicitud de Compra, Orden de Compra, Recibo de Compra, Factura de Compra, Nota de Crédito de Compra, Requisición de Almacén, Factura de Venta, Nota de Crédito de Venta, Diario General, Diario de Presupuesto General, Diario de Artículos, Diario de Inventario Físico.",
    automaticFillInvoiceNo: "Rellenar automáticamente el No. de factura con el No. de entrega del proveedor",
    useGeneralBudgetEntryForPnlBudget: "Usar Entrada de Presupuesto General para Presupuesto de P&L",
    recalledAt: "Recordado En",
    recalledBy: "Retirado Por",
    hideUnitCostColumn: "Ocultar columna de Costo Unitario",
    hideTotalAmountColumn: "Ocultar columna de Total",
    showPrintedDateTime: "Mostrar fecha y hora de impresión",
    printedAt: "Impreso el",
    includedInGop: "Incluido en GOP",
    bankAccountName: "Nombre de la cuenta bancaria",
    chargeDate: "Fecha de Cargo",
    banquet: "Banquete",
    secondaryAccountNo: "Número de cuenta secundaria",
    currentStockOnHand: "SOH Actual",
    baseCurrentStockOnHand: "Base SOH Actual",
    showCurrentSohInPurchaseRequest: "Mostrar SOH Actual en Solicitud de Compra",
    showCurrentSohInPurchaseOrder: "Mostrar SOH Actual en Orden de Compra",
    allowPositiveAdjustmentPhysicalInventory: "Permitir Ajuste Positivo en el Diario de Inventario Físico",
    dimensionValueID: "ID de Valor de Dimensión",
    purchaseRequestMaxBackdatedDays: "Días Máximos Retroactivos",
    purchaseOrderMaxBackdatedDays: "Días Máximos Retroactivos",
    purchaseInvoiceMaxBackdatedDays: "Días Máximos Retroactivos",
    storeRequisitionMaxBackdatedDays: "Días Máximos Retroactivos",
    newQuantity: "Nueva Cantidad",
    editQuantity: "Editar Cantidad",
    requestedQuantity: "Cantidad solicitada",
    allowApproverEditQuantityLessThanOriginal: "Permitir al aprobador editar cantidad menor a la original",
    wht: "WHT",
    hideWhtWhenZero: "Ocultar WHT cuando el monto sea cero",
    useImportWithReservation: "Usar Importar con Reserva",
    includeReservationDetail: "Incluir detalle de reserva",
    contractValidFrom: "Contrato Válido Desde",
    contractValidTo: "Contrato Válido Hasta",
    reconciliationWhtGlAccount: "Cuenta de Retención de Impuestos",
    whtAccountMustDiffer: "La cuenta de retención debe ser diferente de la cuenta GL predeterminada.",
    whtFee: "Impuesto de Retención (%)",
    paymentStatus: "Estado de Pago",
    useCompanyHeaderAndLogoOnPrintout: "Usar encabezado y logo de la empresa en el encabezado de impresión",
    supplierAndHotelVatLabel: "Etiqueta de IVA de Proveedor y Hotel",
    supplierInfo: "Información del Proveedor",
    shipToBillTo: "Enviar a / Facturar a",
    batchHasWhtFee: "Se aplica un impuesto de retención del <strong>{f} %</strong> a este lote.",
    batchHasWhtOptions: "Tasa de retención:",
    freePercentage: "Porcentaje Gratis",
    feeRoundingDigits: "Dígitos de Redondeo de Tarifas (0-3)",
    feeRoundingDigitsRange: "Los dígitos de redondeo de tarifas deben ser un número entero de 0 a 3",
    reconciliationFeeRoundingDigits: "Redondeo de Dígitos de Tarifa de Conciliación (0-3)",
    reconciliationFeeRoundingDigitsHint: "Decimales mantenidos en los montos de descuento del comerciante y retención de impuestos en el Diario de Conciliación de Cuentas",
    creditAccountName: "Nombre de Cuenta de Crédito",
    debitAccountName: "Nombre de Cuenta de Débito",
    defaultCreditAccountName: "Nombre de Cuenta de Crédito Predeterminada",
    defaultDebitAccountName: "Nombre de Cuenta de Débito Predeterminada",
    defaultCreditAccount: "Cuenta de Crédito Predeterminada",
    defaultDebitAccount: "Cuenta de débito predeterminada",
  },
  validation: {
    baseRequired: "Field is required",
    required: "{f} is required",
    longerThan: "{f} must not be longer than {v} characters",
    lineMoreThan: "La línea {f} no debe tener más de {v} líneas",
    exceed: "{f} must not be exceed {v}",
    dateNotAfter: "'{f1}' date should not be after '{f2}'",
    dateNotBefore: "'{f1}' date should not be before '{f2}'",
    dateNotBefore2: "{f1} date should not be before {f2} date ({f3})",
    dateNotBefore3: "{f1} date should not be before {f2} date",
    unitCostExceedOrBelowLastPrice: "Unit cost cannot be above {v1} or below {v2} from last price",
    greaterThan: "El valor debe ser mayor que {v}",
    generalProductPostingGroupRequired: "El Grupo de Publicación de Productos Generales es obligatorio, por favor seleccione del menú desplegable",
    inventoryPostingGroupRequired: "El Grupo de Publicación de Inventario es obligatorio, por favor seleccione del menú desplegable",
    baseUnitOfMeasurementRequired: "La Unidad de Medida Base es obligatoria, por favor seleccione del menú desplegable",
    defaultUnitOfMeasurementRequired: "La Unidad de Medida Predeterminada es obligatoria, por favor seleccione del menú desplegable",
    max20Lines: "La cadena no debe exceder 20 líneas",
    maxLines: "La cadena no debe exceder {f} líneas",
    completeRequiredFields: "Por favor, complete todos los campos obligatorios antes de publicar. Verifique los campos resaltados en la tabla.",
    cannotPostWhenUseSystematicApproval: "No se puede publicar la factura de compra al usar aprobación sistemática",
    dimensionAlreadyInList: "Esta dimensión ya tiene un valor en la lista. Edita esa fila en lugar de añadir una nueva.",
    incompleteDimensionRow: "Cada fila necesita una dimensión y un valor. Completa o elimina la fila incompleta.",
    dimensionsNotLoaded: "No se pudieron cargar las dimensiones actuales. Cierra y vuelve a abrir este diálogo antes de guardar.",
    linesTotalCannotBeNegative: "El total de todas las líneas no puede ser negativo",
    fourDigitYear: "Ingrese un año de 4 dígitos",
    physicalQuantityNegative: "La cantidad física no puede ser negativa. Ingresa la cantidad contada (0 si ninguna).",
    maxBackdatedDaysRange: "Ingrese un número entero de días entre 0 y 30",
    quantityGreaterThanRequested: "La cantidad no puede ser mayor que la solicitada ({v})",
    contractValidToBeforeFrom: "La fecha de validez del contrato no puede ser anterior a la fecha de inicio.",
    idtDeleteOnlyOpen: "Solo se puede eliminar una transferencia abierta o rechazada que no esté publicada.",
  },
  textFormat: {
    addFromReceipt: "Add from Receipt : {f} ",
  },
  l: {
    add: "Agregar",
    addCashDesk: "Agregar Caja",
    addChannel: "Agregar Canal",
    addCity: "Agregar Ciudad",
    addChannelClientCompositionMapping: "Agregar Mapeo de Composición de Cliente de Canal",
    addChannelHotelRateCodeMapping: "Agregar Mapeo de Código de Tarifa de Hotel de Canal",
    addChannelHotelRoomTypeMapping: "Agregar Mapeo de Tipo de Habitación de Hotel de Canal",
    addCountry: "Agregar País",
    addCreditCardType: "Agregar Tipo de Tarjeta de Crédito",
    addGeneralJournal: "Agregar Diario General",
    addJournalAccountType: "Agregar Tipo de Cuenta de Diario",
    addJournalBatch: "Agregar Lote de Diario",
    addJournalTemplate: "Agregar Plantilla de Diario",
    addRoomStatus: "Agregar Estado de Habitación",
    addRoomType: "Agregar Tipo de Habitación",
    adminCode: "Código Administrativo",
    adminName: "Nombre Administrativo",
    adminNameAscii: "Nombre Administrativo ASCII",
    adminType: "Tipo Administrativo",
    backOffice: "Oficina Administrativa",
    bankAccount: "Cuenta Bancaria",
    bankAccountId: "ID de Cuenta Bancaria",
    beverage: "Bebida",
    beverageToday: "Bebida de Hoy",
    bookingSource: "Fuente de Reservas",
    breakdownListAt: "Lista de Desglose en",
    breakdownListOf: "Lista de Desglose de",
    cancel: "Cancelar",
    cancelProcess: "Cancelar proceso",
    capital: "Capital",
    cashDesk: "Caja",
    changeClientPostingGroup: "Cambiar el grupo de publicación del cliente",
    channel: "Canal",
    channelAgencyCode: "Código de Agencia de Canal",
    channelClientCompositionMapping: "Mapeo de Composición de Cliente de Canal",
    channelHotelRateCodeMapping: "Mapeo de Código de Tarifa de Hotel de Canal",
    channelHotelRoomTypeMapping: "Mapeo de Tipo de Habitación de Hotel de Canal",
    channelId: "ID de Canal",
    channelManager: "Gestor de Canal",
    channelRateCode: "Código de Tarifa de Canal",
    channelRoomType: "Tipo de Habitación de Canal",
    channelRoomTypeCode: "Código de Tipo de Habitación de Canal",
    city: "Ciudad",
    cityAlt: "Alt Ciudad",
    cityAscii: "Ciudad ASCII",
    code: "Código",
    country: "País",
    countryId: "ID de País",
    credit: "Crédito",
    creditCard: "Tarjeta de Crédito",
    creditCardType: "Tipo de Tarjeta de Crédito",
    client: "Cliente",
    clientNo: "No. de Cliente",
    clientLedger: "Libro Mayor del Cliente",
    currencyID: "ID de Moneda",
    currencyName: "Nombre de la Moneda",
    dailyFlashCostReport: "Informe Diario de Costos Flash",
    dashboard: "Tablero",
    defaultBookingSource: "Fuente de Reserva Predeterminada",
    defaultMarketSegment: "Segmento de Mercado Predeterminado",
    delete: "Eliminar",
    deleteConfirmation: "Confirmación de Eliminación",
    density: "Densidad",
    description: "Descripción",
    documentNo: "No. de Documento",
    documentType: "Tipo de Documento",
    downloadExcel: "Descargar Excel",
    downloadGSheet: "Descargar GSheet",
    downloadPDF: "Descargar PDF",
    downloadReport: "Download Report",
    downloadReportToGSheet: "Download Report to GSheet",
    downloadReportToGSheetMacro: "Download Report to GSheet (Macro)",
    downloadReportToExcel: "Descargar Informe a Excel",
    downloadReportToExcelMacro: "Download Report to Excel (Macro)",
    edit: "Editar",
    editCashDesk: "Editar Caja",
    editChannel: "Editar Canal",
    editCity: "Editar Ciudad",
    editChannelClientCompositionMapping: "Editar Mapeo de Composición de Cliente de Canal",
    editChannelHotelRateCodeMapping: "Editar Mapeo de Código de Tarifa de Hotel de Canal",
    editChannelHotelRoomTypeMapping: "Editar Mapeo de Tipo de Habitación de Hotel de Canal",
    editCountry: "Editar País",
    editCreditCardType: "Editar Tipo de Tarjeta de Crédito",
    editGeneralJournal: "Editar Diario General",
    editJournalAccountType: "Editar Tipo de Cuenta de Diario",
    editJournalBatch: "Editar Lote de Diario",
    editJournalTemplate: "Editar Plantilla de Diario",
    editRoomStatus: "Editar Estado de Habitación",
    editRoomType: "Editar Tipo de Habitación",
    editCost: "Editar Costo",
    editRemainingQuantity: "Editar cantidad restante",
    editRemainingAmount: "Editar importe restante",
    editRemainingAmountWarning: "Tenga cuidado: esto sobrescribe directamente el importe restante y el estado abierto de un asiento contable registrado. Asegúrese de revisar los asientos relacionados después.",
    internalToolsPostBatchReceipt: "Internal Tools Post Batch",
    internalToolsPostBatchReceiptHint: "Posts released purchase orders for this hotel whose order date falls in the range you set, oldest first, as fully received purchase receipts, up to the limit you set. Receipts are numbered with the prefix exactly as typed, including any trailing space, followed by a running number.",
    internalToolsPostBatchReceiptConfirm: "Post all released purchase orders as fully received purchase receipts?",
    internalToolsPostBatchReceiptFailed: "Failed to post",
    internalToolsPostBatchReceiptNoOrders: "There are no released purchase orders to post.",
    internalToolsPostBatchReceiptDone: "Posted {posted}, failed {failed}.",
    orderDateFrom: "Order Date From",
    orderDateTo: "Order Date To",
    documentNoPrefix: "Document No Prefix",
    documentNoPrefixInvalid: "Prefix contains characters that are not allowed.",
    maxOrdersPerRun: "Max Orders Per Run",
    maxOrdersPerRunInvalid: "Enter a whole number between 1 and {v}.",
    editStoreRequisitionPosted: "Editar Requisición de Almacén Publicada",
    entryNo: "No. de Entrada",
    failed: "Fallido",
    food: "Alimento",
    foodToday: "Alimento de Hoy",
    frontOffice: "Oficina de Recepción",
    generalJournal: "Diario General",
    glAccountID: "ID de Cuenta GL",
    glAccountName: "Nombre de Cuenta GL",
    glAccountNo: "Número de Cuenta GL",
    guestNumber: "Número de Invitado",
    headerDescription: "Descripción del Encabezado",
    hotelAgency: "Agencia de Hotel",
    hotelAgencyGroup: "Grupo de Agencia de Hotel",
    hotelClient: "Cliente de Hotel",
    hotelRate: "Tarifa de Hotel",
    hotelRoomType: "Tipo de Habitación de Hotel",
    importUnitCost: "Costo unitario de importación",
    importQuantity: "Cantidad de Importación",
    iso2Code: "Código ISO2",
    journalAccountNo: "No. de Cuenta de Diario",
    journalAccountType: "Tipo de Cuenta de Diario",
    journalBatch: "Lote de Diario",
    journalTemplate: "Plantilla de Diario",
    latitude: "Latitud",
    lineDescription: "Descripción de Línea",
    lineLocationID: "ID de Ubicación de Línea",
    lineLocationName: "Nombre de Ubicación de Línea",
    lineUnitOfMeasurementID: "ID de la unidad de medida de línea",
    lineUnitOfMeasurementName: "Nombre de la unidad de medida de línea",
    lineNo: "No. de Línea",
    longitude: "Longitud",
    macro: {
      cost: "Costo Macro",
      revenue: "Ingresos Macro",
    },
    mandatory: "Obligatorio",
    marketSegment: "Segmento de Mercado",
    masterData: "Datos Maestros",
    month: {
      _: "Mes",
      list: {
        full: "['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']",
        abbr: "['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic']",
      },
    },
    name: "Nombre",
    new: "Nuevo",
    no: "No",
    numericCode: "Código Numérico",
    ofCreditComplimentary: "de Crédito - Gratuito",
    ofCreditCover: "de Crédito - Cobertura",
    ofCreditOfficeCheck: "de Crédito - Consulta de Oficina",
    ofCreditEntertainment: "de Crédito - Entretenimiento",
    ofPurchaseReceipt: "del Recibo de Compra",
    ofStoreRequest: "de Solicitud de Tienda",
    officialStateName: "Nombre Oficial del Estado",
    originalAmount: "Monto Original",
    paymentTermID: "ID del Término de Pago",
    paymentTermCode: "Código de Condiciones de Pago",
    population: "Población",
    populationProper: "Población Apropiada",
    postingDate: "Fecha de Registro",
    rate: "Tasa",
    ranking: "Clasificación",
    revenueCenterCode: "Código del Centro de Ingresos",
    roomStatus: "Estado de Habitación",
    roomType: "Tipo de Habitación",
    sameName: "Mismo Nombre",
    save: "Guardar",
    simpleMapsCityId: "ID de Ciudad de SimpleMaps",
    successful: "Exitoso",
    timezone: "Zona Horaria",
    vatProdPostGroupCode: "Grupo de Publicación de Producto IVA",
    vatProdPostGroupID: "ID de Grupo de Publicación de Producto IVA",
    whtVatProdPostGroupCode: "Grupo de Publicación de Producto IVA WHT",
    whtVatProdPostGroupID: "ID de Grupo de Publicación de Producto IVA WHT",
    yes: "Sí",
    googleSheets: "Google Sheets",
    debit: "Débito",
    previousBalance: "Saldo anterior",
    billDate: "Fecha de factura",
    aged: "Viejo",
    poNoCoa: "Número de orden / Plan de cuentas",
    receiptNoDesc: "Número de recibo / Descripción",
    documentFlowNotFound: "Flujo de documento con código {f} no encontrado",
    failedToPrint: "Error al imprimir",
    genProdPostGroupID: "ID de Grupo de Publicación de Producto Gen",
    headerClientName: "Nombre del Cliente",
    headerClientAddress: "Dirección del Cliente",
    and: "y",
    cents: "centavos",
    processExpired: "Proceso Expirado",
    revertExpired: "Revertir Caducado",
    notes: "Notas",
  },
  m: {
    confirmDelete: "Are you sure you want to delete {f}? This process cannot be undone.",
    err: {
      betLen: "{f} must be between {v1} and {v2} characters",
      ge: "{f} must be more than or equal {v}",
      gt: "{f} must be more than {v}",
      le: "{f} must be less than or equal {v}",
      lt: "{f} must be less than {v}",
      maxLen: "{f} must be maximum {v} characters",
      maxVal: "The maximum value of {f} is {v}{x}",
      minLen: "{f} must be minimum {v} characters",
      minMaxVal: "Value of {f} must be from {v1}{x} to {v2}{x}",
      minVal: "The minimum value of {f} is {v}{x}",
      number: "{f} must be a number, either positive or negative",
      numeric: "{f} must consist only numeric",
      req: "{f} is required",
    },
    entryEditorWarning: "Ensure that the accounting period remains open and that your user account has the necessary permissions for user posting setup. Any modifications made on this form will be securely logged.",
    entryDeleteBaleWarningUpdate: "Ensure that the all data below here will be re-open because of delete action. Any modification made form this action will be securely logged",
    entryDeleteBaleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all bank account ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    errorEmptyDocumentNumber: "Please choose document number first.",
    successDeleteBale: "Bank account ledger entries has been deleted",
    successDeletePostedInvoice: "Posted invoice has been deleted",
    successMovePurchaseInvoiceLines: "Las líneas de la factura de compra se han movido exitosamente",
    movePurchaseInvoiceLinesWarning: "Esta acción moverá todas las líneas de la factura de compra origen seleccionada a la factura de compra destino. Por favor asegúrese de haber seleccionado las facturas correctas ya que esta operación no se puede deshacer.",
    pleaseSelectTargetPurchaseInvoice: "Por favor seleccione una factura de compra destino",
    sourceTargetPurchaseInvoiceCannotBeSame: "Las facturas de compra origen y destino no pueden ser las mismas",
    successChangeStatusPurchaseRequisition: "Purchase requisition status has been updated",
    setVendorChangePriceReminder: "El costo se determinará según el precio de contrato del proveedor siempre que dicho precio esté disponible",
    successImportGlb: "El presupuesto del libro mayor se ha importado correctamente!",
    successSaveGlb: "¡El presupuesto del libro mayor se ha guardado correctamente!",
    entryDeleteCleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all client ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    entryDeleteVleWarningDelete: "Caution: Proceeding with this action will result in the permanent removal of all vendor ledger entries associated with the specified document number. Please ensure that you have verified the accuracy of the document number, as this operation is irreversible. Any modification made form this action will be securely logged",
    successDeleteCle: "Client ledger entries has been deleted",
    successDeleteVle: "Vendor ledger entries has been deleted",
    successUpdateWitholdingTax: "Witholding Tax has been updated",
    successChangeClientSales: "Client has been updated",
    confirmLogout: "¿Estás seguro de que quieres cerrar sesión?",
    confirmFlushSiteData: "¿Estás seguro de que quieres borrar los datos del sitio? Esto cerrará tu sesión y recargará la página.",
    successFlushSiteData: "Datos del sitio eliminados. Se cerrará tu sesión y la página se recargará.",
    successChangeBankAccount: "La cuenta bancaria ha sido cambiada",
    currBankAccount: "Cuenta Bancaria Corriente",
    successChangeVendor: "El proveedor ha sido cambiado",
    currVendor: "Proveedor Actual",
    successChangeDeliveryNo: "El número de entrega ha sido cambiado",
    currDeliveryNo: "Número de Entrega Actual",
    newDeliveryNo: "Nuevo Número de Entrega",
    entryDeleteWarningUpdate: "Asegúrate de que todos los datos a continuación se reabrirán debido a la acción de eliminación. Cualquier modificación realizada por esta acción se registrará de forma segura.",
    pleaseSelectPurchaseInvoiceFromTheList: "Por favor, seleccione primero una factura de compra de la lista.",
    entryDeleteVeWarningDelete: "Precaución: Al continuar con esta acción, se eliminarán permanentemente todas las entradas de valor asociadas con el número de documento especificado. Asegúrese de haber verificado la exactitud del número de documento, ya que esta operación es irreversible. Cualquier modificación realizada será registrada de forma segura.",
    successDeleteVe: "Las entradas de valor han sido eliminadas",
    entryDeleteGjeWarningDelete: "Precaución: Al proceder con esta acción, se eliminarán permanentemente todos los registros del diario general asociados con el número de documento especificado. Asegúrese de haber verificado la precisión del número de documento, ya que esta operación es irreversible. Cualquier modificación realizada a partir de esta acción será registrada de forma segura.",
    deleteGeneralJournalLogWarning: "Esto no eliminará las entradas del libro mayor, solo este registro.",
    revertPostedInvoiceWarning: "Esta acción eliminará todas las entradas del libro contable relacionadas y establecerá el documento de factura de compra como borrador o no publicado.",
    deletePostedInvoiceWarning: "Esta acción eliminará todas las entradas de libro y el documento de factura de compra relacionados.",
    changeCOAAndDescriptionWarning: "Esta acción solo actualizará desde la línea de la Factura de Compra. Asegúrese de realizar las actualizaciones en los Asientos del Libro Mayor por separado.",
    successCreatePaymentJournal: "Se ha creado el diario de pagos",
    successCreateCashReceiptJournal: "Se ha creado el Diario de Recibos de Efectivo",
    failedZeroRemainingAmount: "No se puede continuar. Algunos datos tienen cantidad restante cero.",
    failedAppliedEntries: "No se puede continuar. Se han aplicado algunos datos en el pago.",
    remainingAmountNotEqualOriginalAmount: "El monto restante no es igual al monto original",
    deletePostedPurchaseCreditMemoWarning: "Esta acción eliminará todas las entradas de libro y el documento de nota de crédito de compra relacionados.",
    successDeletePostedMemo: "El memo publicado ha sido eliminado",
    revertPostedPurchaseCreditMemoWarning: "Esta acción eliminará todas las entradas de libro relacionadas y establecerá el documento de nota de crédito de compra como borrador o no publicado.",
    ytdComparisonYearHint: "Número de años históricos adicionales mostrados en el informe (0-3, 0 = desactivado)",
    entryDeleteDaleWarningDelete: "Precaución: Al proceder con esta acción, se eliminarán permanentemente todas las entradas del libro mayor de la cuenta de depósito asociadas con el número de documento especificado. Asegúrese de haber verificado la precisión del número de documento, ya que esta operación es irreversible. Cualquier modificación realizada a partir de esta acción se registrará de forma segura.",
    successDeleteDale: "Se han eliminado las entradas del libro mayor de la cuenta de depósito",
    successChangeClient: "Cliente cambiado",
    currClient: "Cliente Actual",
    successChangeDepositAccount: "La cuenta de depósito ha sido cambiada",
    currDepositAccount: "Cuenta de Depósito Actual",
    noDimensionsConfigured: "Aún no se han configurado dimensiones para este informe.",
    noDimensionsAvailable: "Todas las dimensiones de este hotel ya están añadidas.",
    dimensionCountNone: "sin dimensiones",
    dimensionCountOne: "1 dimensión",
    dimensionCountMany: "{count} dimensiones",
    saveDimensionOrderFirst: "Guarde el orden actual antes de añadir otra dimensión.",
    gbeRecallWarning: "Recordar este documento elimina permanentemente sus entradas del Registro de Presupuesto General. Las entradas se archivan y pueden revisarse en Recordados. Para restaurarlas, vuelve a ingresar las líneas en el Diario de Presupuesto General y vuelve a publicarlas.",
    gbeRecallSuccess: "{n} entradas de presupuesto recuperadas.",
    deleteSelectedInvoicesWarning: "Esta acción eliminará permanentemente las facturas seleccionadas y todas sus líneas. No se puede deshacer.",
    deleteSelectedInvoicesCount: "Se eliminarán {v} documento(s):",
    invoiceWithoutDocumentNo: "(Sin número de documento)",
    purchaseBookSummaryTruncated: "Los totales cubren solo los primeros {v} registros. Reduce el rango de fechas para un total exacto.",
    changeAccountNumberDimensionNotice: "El conjunto de dimensiones de esta entrada se reemplazará con los valores a continuación, prellenados de las dimensiones obligatorias de {account}. Deje la lista vacía para eliminar el conjunto de dimensiones.",
    changeAccountNumberDimensionAssignNotice: "Esta entrada no tiene dimensiones establecidas. {account} requiere las dimensiones a continuación, predefinidas con sus valores predeterminados. Confirma o ajústalas antes de guardar.",
    successImportCfb: "¡El presupuesto de flujo de caja se ha importado con éxito!",
    successSaveCfb: "¡El presupuesto de flujo de efectivo se ha guardado con éxito!",
  },
  common: {
    add: "Add",
    cancel: "Cancel",
    description: "Description",
    delete: "Delete",
    title: "Title",
    save: "Save",
    faq: "FAQ",
    contact: "Contact Us",
    tos: "Terms of Service",
    policy: "Privacy Policy",
    sunday: "Domingo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    clickHere: "Haz clic aquí",
    standard: "Estándar",
    monospace: "Monoespaciado",
    left: "Izquierda",
    center: "Centro",
    right: "Derecha",
  },
  board: {
    titlePlaceholder: "Enter a title for this card",
    deleteDescription: "Are you sure you want to delete this card?",
    editCard: "Edit Card",
    deleteCard: "Delete Card",
    state: {
      TODO: "TO DO",
      INPROGRESS: "INPROGRESS",
      TESTING: "TESTING",
      DONE: "DONE",
    },
  },
  chat: {
    online: "Users Online ({count})",
    addChannel: "Add Channel",
    channel: "Channel | Channels",
    message: "Message",
  },
  email: {
    compose: "Compose Email",
    send: "Send",
    subject: "Subject",
    labels: "Labels",
    emptyList: "Empty email list",
    inbox: "Inbox",
    sent: "Sent",
    drafts: "Drafts",
    starred: "Starred",
    trash: "Trash",
    work: "Work",
    invoice: "Invoice",
    recipient: "Destinatario",
  },
  todo: {
    addTask: "Add Task",
    tasks: "Tasks",
    completed: "Completed",
    labels: "Labels",
  },
  dashboard: {
    activity: "Activity",
    weeklySales: "Weekly Sales",
    sales: "Sales",
    recentOrders: "Recent Orders",
    sources: "Traffic Sources",
    lastweek: "vs last week",
    orders: "Orders",
    clients: "Clients",
    tickets: "Support Tickets",
    viewReport: "View Report",
  },
  usermenu: {
    profile: "Profile",
    signin: "Sign In",
    dashboard: "Dashboard",
    signout: "Sign Out",
  },
  error: {
    failedFetchItemCost: "No se pudo obtener el último costo del artículo",
    glbImport: "Error, no se puede importar el presupuesto del libro mayor",
    notfound: "Page Not Found",
    other: "An Error Ocurred",
    invoiceAlreadyHaveCreditMemo: "This invoice already has a Credit Memo",
    POItemIsFromPR: "Purchase Order item where the source is coming from Purchase Request",
    locationAndPostingGroupDuplicate: "This location ({f1}) and posting group ({f2}) already exist.<br/>Please choose another value!",
    businessAndProductPostingGroupDuplicate: "This business ({f1}) and product posting group ({f2}) already exist.<br/>Please choose another value!",
    invoiceAlreadyPaid: "This invoice has been paid in part or in full.<br/>Original Amount: {f1}<br/>Remaining Amount: {f2}",
    needConfigureVatProduct: "Por favor, configure la publicación de productos de IVA en la configuración del cliente o de cuentas por cobrar",
    differentVATGroup: "Los grupos de publicación de productos de IVA deben ser iguales",
    syncPrLineFailed: "Error al sincronizar cambios en la línea de Solicitud de Compra. Los cambios en la OC se guardaron.",
    needConfigureDirectCostAccount: "Por favor, configure la Cuenta de Costo Directo en la Configuración de Cuentas por Pagar",
    needConfigurePurchaseAccount: "Por favor, configure la Cuenta de Compra en la Configuración de Cuentas por Pagar",
    noPermission: "No tienes permiso para realizar esta acción",
    cfbImport: "Error, no se puede importar el presupuesto de flujo de caja",
    noAppliedEntriesOnThisDocument: "No hay entradas aplicadas en este documento",
    noCompanyHeaderInfo: "Sin información de encabezado de la empresa. Contacta a tu administrador.",
  },
  check: {
    title: "Set New Password",
    backtosign: "Back to Sign In",
    newpassword: "New Password",
    button: "Set new password and Sign in",
    error: "The action link is invalid",
    verifylink: "Verifying link...",
    verifyemail: "Verifying email address...",
    emailverified: "Email verified! Redirecting...",
  },
  forgot: {
    title: "Forgot Password?",
    subtitle: "Enter your account email address and we will send you a link to reset your password.",
    email: "Email",
    button: "Request Password Reset",
    backtosign: "Back to Sign In",
  },
  login: {
    title: "Sign In",
    email: "Email",
    password: "Password",
    button: "Sign In",
    orsign: "Or sign in with",
    forgot: "Forgot password?",
    noaccount: "Don't have an account?",
    create: "Create one here",
    error: "The email / password combination is invalid",
  },
  register: {
    title: "Create Account",
    name: "Full name",
    email: "Email",
    password: "Password",
    passwordRetype: "Retype Password",
    button: "Create Account",
    orsign: "Or sign up with",
    agree: "By signing up, you agree to the",
    account: "Already have an account?",
    signin: "Sign In",
  },
  utility: {
    maintenance: "In Maintenance",
  },
  faq: {
    call: "Have other questions? Please reach out ",
  },
  ecommerce: {
    products: "Products",
    filters: "Filters",
    collections: "Collections",
    priceRange: "Price Range",
    clientReviews: "Client Reviews",
    up: "and up",
    brand: "Brand",
    search: "Search for product",
    results: "Results ( {0} of {1} )",
    orders: "Orders",
    shipping: "Shipping",
    freeShipping: "Free Shipping",
    inStock: "In Stock",
    quantity: "Quantity",
    addToCart: "Add To Cart",
    buyNow: "Buy Now",
    price: "Price",
    about: "About this item",
    description: "Description",
    reviews: "Reviews",
    details: "Product Details",
    cart: "Cart",
    summary: "Order Summary",
    total: "Total",
    discount: "Discount",
    subtotal: "Subtotal",
    continue: "Continue Shopping",
    checkout: "Checkout",
  },
  menu: {
    rateManagement: "Gestión de Tarifas",
    reservation: "Reserva",
    reservationNew: "Nueva",
    reservationList: "Lista",
    frontOffice: "Recepción",
    generalSettings: "Configuración General",
    guestTitle: "Título del Huésped",
    guestDocumentType: "Tipo de Documento del Huésped",
    manageHotel: "Hotel",
    hotel: "Hotel",
    hotelList: "Lista",
    hotelCategory: "Categoría del Hotel",
    hotelChain: "Cadena de Hoteles",
    marketSegment: "Segmento de Mercado",
    rooms: "Habitaciones",
    currency: "Moneda",
    search: "Buscar (presione \"ctrl + /\" para enfocar)",
    dashboard: "Tablero",
    logout: "Cerrar sesión",
    flushSiteData: "Eliminar datos del sitio",
    clearCache: "Limpiar Caché",
    profile: "Perfil",
    blank: "Página en Blanco",
    pages: "Páginas",
    others: "Otros",
    email: "Correo Electrónico",
    chat: "Chat",
    todo: "Por Hacer",
    board: "Tablero de Tareas",
    users: "Usuarios",
    usersList: "Lista",
    usersEdit: "Editar",
    ecommerce: "Comercio Electrónico",
    ecommerceList: "Productos",
    ecommerceProductDetails: "Detalles del Producto",
    ecommerceOrders: "Pedidos",
    ecommerceCart: "Carrito",
    auth: "Páginas de Autenticación",
    authLogin: "Iniciar sesión",
    authRegister: "Registrarse",
    authVerify: "Verificar Correo Electrónico",
    authForgot: "Olvidé mi Contraseña",
    authReset: "Restablecer Contraseña",
    errorPages: "Páginas de Error",
    errorNotFound: "No Encontrado / 404",
    errorUnexpected: "Inesperado / 500",
    utilityPages: "Páginas de Utilidad",
    utilityMaintenance: "Mantenimiento",
    utilitySoon: "Próximamente",
    utilityHelp: "FAQs / Ayuda",
    levels: "Niveles del Menú",
    disabled: "Menú Deshabilitado",
    docs: "Documentación",
    feedback: "Comentarios",
    support: "Soporte",
    history: "Historia",
  },
  localColumns: {
    defaultVatProductPostingGroup: "Grupo de Contabilización de Producto de IVA Predeterminado",
    defaultWhtProductPostingGroup: "Grupo de Contabilización de Retención Predeterminado",
    isWitholdingTax: "¿Es Impuesto de Retención?",
    isNoVat: "¿Es No IVA?",
    batchName: "Nombre del lote",
    batchCode: "Codigo del lote",
    totalRecords: "Total de registros",
    totalAmount: "Monto total",
    totalDebit: "Débito total",
    totalCredit: "Crédito total",
    postingGroup: "Grupo de publicación",
    inventoryPostingType: "Tipo de publicación de inventario",
    postingType: "Tipo de publicación",
    journalName: "Nombre del Diario",
    company: "Empresa",
    offsetCompany: "Empresa de Compensación",
    offsetAccount: "Cuenta de Compensación",
    isPom: "¿Es POM?",
    sentecAccountNo: "Número de Cuenta Sentec",
    sentecAccountName: "Nombre de Cuenta Sentec",
    salesPersonName: "Nombre del Vendedor",
    guestAccountName: "Invitado / Nombre de Cuenta",
    contactPersonName: "Nombre de la Persona de Contacto",
    creditLimit: "Límite de Crédito",
    remainingBalance: "Saldo Restante",
    vleAmount: "Cantidad VLE",
    gleAmount: "Cantidad GLE ",
    cleAmount: "Cantidad CLE ",
    diff: "Diff",
    SOHQuantity: "Cantidad SOH",
    IABQuantity: "Cantidad IAB",
    SOHTotalCost: "Costo Total SOH",
    COAAmount: "Monto COA",
    costDifference: "Diferencia de Costo",
    isGeneralStorage: "Es Almacenamiento General",
    generalLedgerEntryId: "ID de Asiento del Libro Mayor",
    operator: "Operador",
    ilePostingDate: "Fecha de Publicación ILE",
    receivableDate: "Fecha de Recepción",
    receivableDueDate: "Fecha de Vencimiento de Cobro",
    receivablePostingDate: "Fecha de Registro de Cuentas por Cobrar",
  },
  localCommon: {
    noMenuMatchedWithSearchQuery: "No Menu Matched With Search Query",
    top10VendorByBalance: "Top 10 Proveedores por Saldo",
    top10ClientsByBalance: "Top 10 Clientes por Saldo",
    chooseTime: "Elegir Tiempo",
    top10PurchaseItem: "Top 10 Artículos de Compra",
    split: "Dividir",
    postBatch: "Publicar Lote",
    processing: "Procesando",
    inventory: "Inventario",
    adjustEntry: "Ajustar entrada",
    generalLedgerBudget: "Presupuesto del Libro Mayor",
  },
  coaIntegration: {
    title: "Integración COA",
    titleMapping: "Mapeo COA",
    provider: "Proveedor",
    dataLog: "Registro de Datos",
    flushDataLog: "Vaciar Datos",
    successSaveConfig: "La configuración ha sido actualizada",
    successGenerateData: "Los datos han sido generados",
    successSendData: "Los datos han sido procesados, por favor verifica la respuesta",
    successFlushData: "El registro de datos ha sido vaciado",
    successUpdateMappingData: "El mapeo ha sido actualizado",
    successDeleteMappingData: "El mapeo ha sido eliminado",
    inputSystemChartOfAccount: "Sistema de Plan de Cuentas",
    deleteMappingConfirm: "¿Estás seguro de que deseas eliminar este registro? Este proceso no se puede deshacer.",
    deleteDataLogByMonthConfirm: "¿Está seguro de que desea eliminar todos los registros basados en el mes seleccionado? Este proceso no se puede deshacer.",
    deleteDataLogAllConfirm: "¿Está seguro de que desea eliminar todos los registros? Este proceso no se puede deshacer.",
    baseUrl: "URL base",
  },
  generalLedgerBudget: {
    editTitle: "Editar Presupuesto",
    title: "Importar desde XLS",
    successImportData: "¡Los datos han sido importados!",
  },
  balanceSheetConsolidation: {
    title: "Consolidación del Balance General",
    titleReport: "Informe de Consolidación del Balance General",
    excelFileID: "ID de Archivo de Excel de Consolidación del Balance General",
    sheetFileID: "ID de Archivo de Google Sheet de Consolidación del Balance General",
  },
  $vuetify: {
    badge: "Badge",
    close: "Close",
    dataIterator: {
      noResultsText: "No matching records found",
      loadingText: "Loading items...",
    },
    dataTable: {
      itemsPerPageText: "Rows per page:",
      ariaLabel: {
        sortDescending: "Sorted descending.",
        sortAscending: "Sorted ascending.",
        sortNone: "Not sorted.",
        activateNone: "Activate to remove sorting.",
        activateDescending: "Activate to sort descending.",
        activateAscending: "Activate to sort ascending.",
      },
      sortBy: "Sort by",
    },
    dataFooter: {
      itemsPerPageText: "Items per page:",
      itemsPerPageAll: "All",
      nextPage: "Next page",
      prevPage: "Previous page",
      firstPage: "First page",
      lastPage: "Last page",
      pageText: "{0}-{1} of {2}",
    },
    datePicker: {
      itemsSelected: "{0} selected",
      nextMonthAriaLabel: "Next month",
      nextYearAriaLabel: "Next year",
      prevMonthAriaLabel: "Previous month",
      prevYearAriaLabel: "Previous year",
    },
    noDataText: "No data available",
    carousel: {
      prev: "Previous visual",
      next: "Next visual",
      ariaLabel: {
        delimiter: "Carousel slide {0} of {1}",
      },
    },
    calendar: {
      moreEvents: "{0} more",
    },
    fileInput: {
      counter: "{0} files",
      counterSize: "{0} files ({1} in total)",
    },
    timePicker: {
      am: "AM",
      pm: "PM",
    },
    pagination: {
      ariaLabel: {
        wrapper: "Pagination Navigation",
        next: "Next page",
        previous: "Previous page",
        page: "Goto Page {0}",
        currentPage: "Current Page, Page {0}",
      },
    },
  },
  userPostingSetup: {
    setPostingDate: "Establecer Fecha de Publicación para Todos los Usuarios",
  },
  purchaseRequisitionBatch: {
    allowedApprovalSubmissionDays: "Días Permitidos para la Presentación de Aprobaciones",
  },
  documentFlow: {
    purchaseInvoiceDefaultDocumentFlow: "Flujo de Documento Predeterminado de Factura de Compra",
    purchaseInvoiceDocumentFlowRules: "Reglas de Flujo de Documentos de Factura de Compra",
    equal: "Igual",
    notEqual: "No Igual",
    lessThan: "Menor Que",
    lessThanOrEqual: "Menor o Igual Que",
    greaterThan: "Mayor Que",
    greaterThanOrEqual: "Mayor o Igual Que",
    purchaseOrderDocumentFlowRules: "Reglas de Flujo de Documentos de Orden de Compra",
    purchaseReceiptDocumentFlowRules: "Reglas de Flujo de Documentos de Recibo de Compra",
    default: "Flujo de Documentos Predeterminado",
    purchaseOrderDMLDocumentFlowRules: "Reglas de Flujo de Documentos de Orden de Compra de Lista de Mercado Diario",
    documentsSourceInformation: "Los documentos mostrados en esta página son exclusivamente del Back Office (p. ej., PI, PO, PR, etc.). Los documentos generados por el Front Office se pueden ver en el módulo de Front Office.",
    refreshApprovals: "Actualizar Aprobaciones",
    showInformation: "Mostrar Información",
    submitForApprovalConfirmation: "Las solicitudes de aprobación se enviarán por correo electrónico a estos usuarios. Asegúrese de que la información sea correcta.",
    hideInformation: "Ocultar Información",
    documentFlowBeingUsed: "Flujo de Documento en Uso",
    sendEmail: "Enviar correo",
    sendReminder: "Enviar Recordatorio",
    reminderCount: "Conteo de Recordatorios",
    remindedAt: "Recordado el",
  },
  changesLog: {
    logCategory: "Categoría de Registro",
    sourceId: "ID de origen",
  },
  taxSubmission: {
    availableToCancelOrReject: "Disponible para cancelar/rechazar",
    availableToGetSubmittedDetails: "Disponibles para obtener detalles enviados",
    availableToSend: "Disponible para enviar",
    buyerAddress: "Dirección del Comprador",
    buyerContractName: "Nombre del Contrato del Comprador",
    buyerName: "Nombre del Comprador",
    buyerRegistrationNumber: "Número de Registro del Comprador",
    buyerSSTRegistrationID: "ID de Registro SST del Comprador",
    buyerTIN: "NIT del comprador",
    classification: "Clasificación",
    eInvoice: "Factura electrónica",
    eInvoiceCode: "Código de e-Factura",
    eInvoiceType: "Tipo de e-Factura",
    eInvoiceVersion: "Versión de e-Factura",
    invoiceDateAndTime: "Fecha y hora de la factura",
    originalInvoiceRefNo: "Ref. No. Factura Original: No Aplicable",
    sendCountInvoicesToTaxInterface: "Enviar {count} facturas a la interfaz fiscal",
    subtotal: "Subtotal",
    supplierBusinessActivityDescription: "Descripción de la actividad comercial del proveedor",
    supplierMSICCode: "Código MSIC del proveedor",
    supplierRegistrationNumber: "Número de Registro del Proveedor",
    supplierSSTID: "ID SST del proveedor",
    supplierTIN: "NIT del proveedor",
    taxRate: "Tasa de Impuesto",
    totalExcludingTax: "Total sin impuestos",
    totalIncludingTax: "Total con impuestos",
    totalPayableAmount: "Monto total a pagar",
    uniqueIdentifierNo: "Número de Identificación Único",
    unitPrice: "Precio Unitario",
    digitalSignature: "Firma Digital",
    validationDateTime: "Fecha y Hora de Validación",
    visualPresentation: "Este documento es una presentación visual de la e-Factura",
    na: "N/A",
    getSubmittedDocumentURL: "Obtener URL del Documento Enviado",
    cancelOrRejectDocument: "Cancelar o Rechazar Documento",
    interfaceStatus: "Estado de la Interfaz",
    receiptVerificationRedirectURL: "URL de Redirección para Verificación de Recibo",
    receiptVerificationSubmissionUUID: "UUID de Envío de Verificación de Recibo",
    receiptVerificationDocumentUUID: "UUID del Documento de Verificación de Recibo",
    reject: "Rechazar",
  },
  template: {
    columnLengthDifference: "Plantilla inválida: el conteo de columnas no coincide.",
  },
  cashFlowBudget: {
    editTitle: "Editar Presupuesto",
    title: "Importar de XLS",
    successImportData: "¡Los datos han sido importados!",
  },
};
